
import React, { Component, createRef  } from "react";
import CheckIcon from '@mui/icons-material/Check';
import { get, post, del, getFreshToken } from '../../custom_libraries/serverRequests';
import urls from '../../custom_libraries/urls';
import '../adminDash.css';
import axios from "axios"; // Import axios for API requests
import no_img from '../../assets/No_Image_Available (4).jpg';
import globalVariables from "../../custom_libraries/globalVariables";
import withNavigate from "../../Global_files/WithNavigate";
import NoCameraConnected from "../../assets/cam-offline.jpg"
import MinusIcon from "../../assets/icons8-minus-32.png"
import PlusIcon from "../../assets/icons8-plus-32.png"
import ExclaimIcon from "../../assets/icons8-exclamation-32.png"
import Navigationbar from '../Navigationbar';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Tooltip from '@mui/material/Tooltip';
//import mui components to inhance the look
import { Button, Snackbar, Alert } from '@mui/material';
import { Devices, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Link } from "react-router-dom";
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
        Paper, IconButton, Typography, Collapse, Box,Tabs, Tab, Select, MenuItem, Menu } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import LinkIcon from '../../assets/ip-globe-icon.png';
import ScheduleIcon from '@mui/icons-material/Schedule';
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';
import DialogBox from '../DialogBox';
import Scheduler from './Scheduler';
import EditIconImage from '../../assets/icons8-edit-new-64.png';
import SameImageStatus from '../../assets/icons8-check-active.png';
import DiffImageStatus from '../../assets/icons8-cross-48.png';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';
// import SyncIcon from '../../assets/icons8-synchronize-48.png';
import SyncIcon1 from '../../assets/icons8-synchronize-96-1.png';
import { fabric } from 'fabric';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CameraCanvas from './CameraCanvas';
import DeviceSpecificNotifications from '../Settings/DeviceSpecificNotifications';
import { Switch, FormControlLabel } from '@mui/material';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import SubjectIcon from '@mui/icons-material/Subject';
import TextField from '@mui/material/TextField';
// import CloudIcon from '@mui/icons-material/Cloud';
import InternetConnectionDetector from "../../Global_files/InternetConnectionDetector";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import passwordEye from '../../assets/icons8-eye-64.png';
// import EditIcon from '@mui/icons-material/Edit';
import EditNoteIcon from '@mui/icons-material/EditNote';
import BlockRoundedIcon from '../../assets/icons8-block-64.png';
import SmsNotificationsSettings from '../Settings/SmsNotificationsSettings';
import DeviceLevelRocketChat from "./DeviceLevelRocketChat";
//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";
import VpnLockRoundedIcon from '@mui/icons-material/VpnLockRounded';

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      // default: "#0d0d0d",
      // paper: "#000000",
      default: "#191e29",
      paper: "#2e3442",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------

class AboutDevice extends Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
    this.canvas = null;

    this.state = {
      selectedSite: null,
      selectedSiteInfo: null, 
      cameras: [],
      loading: true,
      devices: [],
      searchInput: "",
      currentPage: 1,
      rowsPerPage: 5,
      device_details: [],

      expandedRow: null, // Track which row is expanded
      nestedExpandedRow: null,
      ref_img_created_time: null,
      ref_img_next_inspection: "",
      latest_img_taken_at: null,
      capturedImageBlob: null,
      capturedLatestImageBlob: null,
      currentTime_of_device: null,
      selectedCamera: null,
      isPopupVisible: false,
      activeSection: 'reference',	// State to track the active collapsible section

      deviceId: '',
      snackbar_msg: '',
      open_snackbar: false,

      confirmDialog: {
        isOpen: false,
        title: '',
        subtitle: '',
      },

      confirmDeleteDialog: {
        isOpen: false,
        title: '',
        subtitle: '',
      },

      open_MuteUnmute_Dialogue: false,
      mute: true,
      selectedCameraId: null,
      muteResponseMessage: '',
      error2: false,
      success2: false,
      success: false,

      image1: '',
      ref_img_id: null,
      image2: '',
      imageURL: "",

      site_list: [],
      filteredDevices: [], // Devices to display based on filter

      refreshSystemOverviewstatuscard: false,

      //add site----
      toggleAddSite: false,
      sitename: '',
      address: '',
      city:'',
      street:'',
      zip:'',
      country:'',
      state:'',
      organisationName: '',
      warning_site: false,
      success_site: false,
      error_site: false,
      open_progress_bar: false,
      user_name:'',
      user_type:'',
      client_list:[],
      selected_Customers:[],
      Selected_Device_Id:null,
      SiteName:'',
      DeviceName:'',

      activeTab: 0, // Default to the first tab (General Info)
      templateEditToggle: false,
      template_list: [],
      template_name : '',
      
      toggleIgnoreZone:false,
      showDiskDetails:false,

      showDeviceUserList: false,
      selectedDeviceForUserList:null,
      // camera_id_for_ignore_zone: null, 
      send_image_path: false,
      latest_image_path: null,
      // Toggle for Arm Disarm
      // deviceIdForArmDisarm: null,
      isDeviceArmed: true,  // or false based on initial state
      showArmDialog: false,
      armDisarmLoading: false, // after request
      selectedSchedules: {
      schedule1: true
      },
      deviceStatusMap: "active",
      numberOfDays: '',
      daysError: '', // holds validation message
      cameraCloudStatus: {},  // cameraId: true/false
      storage_templates_list: [],
      storage_template_name: '',
      applied_storage_template: '',
      applied_days_for_storage: '',
      pagination: {
        count: 0,
        next: null,
        previous: null,
        currentPage: 1,
      },
      cloudStorageStatusMap : false,

      hoveredCameraImage: null,
      hoveredCameraImageTimestamp: null,
      hoverPosition: { x: 0, y: 0 },
      toggleAddSingleCamera: false,
      CameraName: '',
      rtspStreamParameter: '',
      warning_camera: false,
      error_camera: false,
      success_camera: false,
      is_rtsp_device: false,
      ShowarmStatusMessage: false,
      manualDisarmMessage: "",  // 🆕 For showing alert message
      showManualDisarmAlert: false, // 🆕 To control visibility
      anchorE2:null,
      EditCameraName:'',
      EditRTSPAddress:'',
      editCameraToggle:false,
      error_camera_edit: false,
      success_camera_edit: false,

      editDeviceToggle:false,
      // unmute_count:0,
      error_device_edit: false,
      success_device_edit: false,
      storedLogo: localStorage.getItem("USER_LOGO") || null,
      warning_device : false,
      error_camera_message: "",
      errors: {},
      responseMessage:'',
      open_CameraHealth_MuteUnmute_Dialogue: false,
      Camera_report_mute: false,
      CameraHealthMuteCount : null, 
      VideoAnalysisUnmuteCount : null,
      CameraHealthUnmuteCount : null,
      IsCameraHealthScheduleSet : false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.validateSignedIn();
    }, 0);
    // const siteId = localStorage.getItem(globalVariables.SITE_ID);
    // console.log(" Component did Mount Site ID, Cloud_storage_status :",siteId, CloudStorageStatus);

    const siteName = localStorage.getItem(globalVariables.SITE_NAME);
    const deviceName= localStorage.getItem(globalVariables.DEVICE_NAME);
    const Selected_Device_Id = localStorage.getItem(globalVariables.DEVICE_ID);
    const IsRtspDevice = localStorage.getItem(globalVariables.IS_RTSP_DEVICE);
    this.setState({ Selected_Device_Id }, () => {
      this.LoadSelectedDeviceInfo();
      this.fetchDeviceStatus(); // Fetch device status after setting Selected_Device_Id
      // this.getAppliedStorageTemplateForDevice(Selected_Device_Id);
      this.getRecordingPolicyTemplateForDevice(Selected_Device_Id);
      this.fetchVAScheduleData(Selected_Device_Id);
      this.fetchDeviceTypes();
      // this.setState({
      //     deviceIdForArmDisarm: parseInt(Selected_Device_Id)
      //   }, () => {
      //     this.fetchArmStatus(); // ✅ safe to call now: this function is no more in use as this API call is reduced and now the arm status is getting fetched from the device Info itself.
      //   });
    });
    const user_type = localStorage.getItem(globalVariables.USER_TYPE);
    // const storedLogo = localStorage.getItem("USER_LOGO");
    this.setState ({
        SiteName : siteName,
        DeviceName : deviceName,
        user_type : user_type,
        is_rtsp_device : IsRtspDevice === 'True' ? true : false,
    })
    // this.handleFetchTemplate();
    this.getCloudStorageTemplates();

    // Add event listener for keydown
    document.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener("keydown", this.handleEscKeyDown);


    //-------- Initialize Fabric.js canvas only once-----
    this.canvas = new fabric.Canvas(this.canvasRef.current);
    // Bind Fabric.js events
    this.canvas.on("mouse:down", this.handleMouseDown);
    this.canvas.on("mouse:move", this.handleMouseMove);
    this.canvas.on("mouse:up", this.handleMouseUp);
  }

  validateSignedIn = async () => {
    try {
      let is_fresh_token = await getFreshToken();
      console.log("Fresh Token:", is_fresh_token);
  
      if (!is_fresh_token) {
        console.log("Navigating to login...");
        this.props.navigate("/");
        return;
      }
      console.log("token validated.")
    } catch (error) {
      console.error("Error in validateSignedIn:", error);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    
    const commonFlagsChanged =
        this.state.warning_device !== prevState.warning_device || 
        this.state.success_camera !== prevState.success_camera ||
        this.state.error_camera !== prevState.error_camera ||
        this.state.warning_camera !== prevState.warning_camera ||
        this.state.success_camera_edit !== prevState.success_camera_edit ||
        this.state.error_camera_edit !== prevState.error_camera_edit ||
        this.state.warning_camera_edit !== prevState.warning_camera_edit ||
        // this.state.ShowarmStatusMessage !== prevState.ShowarmStatusMessage ||
        this.state.error_device_edit !== prevState.error_device_edit ||
        this.state.success_device_edit !== prevState.success_device_edit ;
    if (commonFlagsChanged) {
        if (
            this.state.warning_device ||
            this.state.success_camera ||
            this.state.error_camera ||
            this.state.warning_camera ||
            this.state.error_camera_edit ||
            this.state.warning_camera_edit ||
            this.state.success_camera_edit ||
            // this.state.ShowarmStatusMessage ||
            this.state.error_device_edit ||
            this.state.success_device_edit
        ) {
            setTimeout(() => {
                this.setState({
                    warning_device: false,
                    success_camera: false,
                    error_camera: false,
                    warning_camera: false,
                    success_camera_edit: false,
                    error_camera_edit: false,
                    warning_camera_edit: false,
                    // ShowarmStatusMessage: false,
                    error_device_edit: false,
                    success_device_edit: false,
                    error_camera_message: ""
                });
            }, 3000); // 1 second
        }
    }
    // ShowarmStatusMessage (custom timer)
  if (
    this.state.ShowarmStatusMessage !== prevState.ShowarmStatusMessage &&
    this.state.ShowarmStatusMessage
  ) {
    setTimeout(() => {
      this.setState({ ShowarmStatusMessage: false });
    }, 10000); //  Increased timer 10 seconds
  }
}

    componentWillUnmount() {
      // Remove event listener for keydown
      document.removeEventListener("keydown", this.handleKeyDown);
      document.removeEventListener("keydown", this.handleEscKeyDown);

    }
  
    handleKeyDown = (event) => {
      if (event.key === "Escape") {
        // Close modal when Esc key is pressed
        this.handleCloseModal();
        this.handleCloseUserListModal();
      }
    };

    handleEscKeyDown = (event) => {
      if (event.key === "Escape") {
        // Close modal when Esc key is pressed
        this.handleCloseUserListModal();
      }
    }

  syncSelectedDevice = async() => {
    const{Selected_Device_Id, is_rtsp_device} = this.state
    console.log("-----syncSelectedDevice----Selected_Device_Id----is_rtsp_device", Selected_Device_Id, is_rtsp_device);
    if(is_rtsp_device === true){
      this.startLoading();
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
      let headers = {
                // 'content-type': 'application/json',
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${access_tocken}`
            };
      let response = await post(urls.TEST_CONNECTION_FOR_RTSP_DEVICE(Selected_Device_Id), headers);
        console.log("---TestConnection--RTSP_DEVICE---data--",response);
        this.stopLoading();
        if (response.data?.message === "Camera test completed.") {
              
              this.openSnackbar("RTSP device is synced successfully!", 'success');
              console.log("response.data.results" , response.data.results || []);
              setTimeout(() => {
                this.LoadSelectedDeviceInfo();
              }, 2000);
          }
          else if (response.error && response.error.length > 0){
            console.log("inside else error block for rtsp test connection");
           
            this.openSnackbar(response.error[0], 'error');
          }
          else {
            this.openSnackbar('Failed to sync this device', 'error');
          }
    }
    else{
      this.RefreshDeviceInfo();
    }
  }

  RefreshDeviceInfo = async () => {
    const { devices } = this.state;
    console.log("--------device---------", devices);
    let deviceData = {
      "device_id": devices.id,
      // "device_name": devices.device_name,
      "vendor": devices.device_type,
      // "sitedb": devices.sitedb,
      "ip_address": devices.ip_address,
      "protocol": devices.protocol, // Convert to lowercase and remove '://'
      "port_number": devices.port_number,
      "device_username": devices.device_username,
      "device_password": devices.device_password,
      // "rtsp_port": devices.rtsp_port,
      // "policy_template_id": devices.recording_policy
      };
    //   let data = {
    // "device_id": 2,
    // "vendor": "nvr",
    // "protocol": "http",
    // "ip_address": "lemona14.ddns.net",
    // "port_number": 80,
    // "device_username": "admin",
    // "device_password": "Global1900?"
    // }
      const data = JSON.stringify(deviceData)
      console.log("--------deviceData---------", data);
     try {
      this.startLoading()
       let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
       console.log("--------auth tocken RefreshDeviceInfo---------", access_tocken);
       let headers = {
           'content-type': 'application/json',
           'Authorization': `Bearer ${access_tocken}`
       }
      //  const url = urls.REFRESH_DEVICE;  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
      //  const response = await post(urls.REFRESH_DEVICES, data, headers); // Perform the API call using the constructed URL
       const response = await post(urls.SYNC_DEVICE, data, headers); // Perform the API call using the new constructed URL
       console.log(`API Response for RefreshDeviceInfo:`, response);
       if (response && response.taskIds.length > 0 ) {
        setTimeout(() => {
          // this.LoadSelectedDeviceInfo();
          this.stopLoading();
          this.openSnackbar(response.message || "Syncing the device info successfully, the info will update shortly!", 'success');
        }, 1500); // 5.5 seconds delay
       
       }
       
       else if (response == false || response.responseMessage){
        this.stopLoading();
        this.openSnackbar(response.responseMessage || "Failed to refresh the device. Please try again.", 'error')
        }
        else {  //added this block for rtsp device refresh case when no task is created in backend.
          this.stopLoading();
          this.openSnackbar(response.error[0] || "Failed to refresh the device. Please try again.", 'error')
        }
      //  if (response && Object.keys(response).length > 0) {
      //    console.log(`API Response for RefreshDeviceInfo:`, response);
      //    this.setState({ 
      //     devices:response
      //     });
 
      //  } else {
      //    console.error("No valid data returned from the get-camera API");
      //  }
     } catch (error) {
       console.error("Error fetching cameras from API:", error);
       this.openSnackbar(error || "Failed to sync the device. Please try again.", 'error')
        
     }
   }

  handleTabChange = (event, newValue) => {
    this.setState({ activeTab: newValue });
    if(newValue === 0){
      this.LoadSelectedDeviceInfo();
    }
  };

  /** 
   * getCamerasList() function fetches the camera list w.r.t selected device (row from device list table). this function gets invoked from when clicked on the row of device list table.
  **/
  getCamerasList = async (deviceId, page = 1) => {
    this.setState({ loading: true })
    try {
      
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_tocken}`
      }

      console.log("camera list record policy -------------->:", this.state.device_details.recording_policy_days);
      //this.setState({ : [] }); 
      // URL with pagination
      const url = urls.CAMERAS_BY_DEVICE_WITH_PAGINATION(deviceId, page);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
      const response = await get(url, headers); // Perform the API call using the constructed URL
      console.log(`API Response for CAMERAS_BY_DEVICE_WITH_PAGINATION ${deviceId}:`, response);
      if (response?.results && Array.isArray(response.results) && response.results.length > 0) {
        this.setState(
          (prevState) => ({ 
          cameras: 
          page === 1
                ? response.results // reset on first page
                : [...prevState.cameras, ...response.results], // append new data,
          pagination: {
              count: response.count,
              next: response.next,
              previous: response.previous,
              currentPage: page,
            },
          loading: false 
        }), () => {
        // ✅ After cameras are set, fetch cloud storage status for each camera
      //   response.results.forEach((camera) => {    // TODO : uncomment this whenever 'cloud storage template' tab is uncommented to use.
      //     this.fetchCameraCloudStatus(camera.id);
      // });
});

      } else {
        console.error("No valid data returned from the get-camera API");
        this.setState({ cameras: [], loading: false }); // Ensure cameras list is cleared for invalid data
      }
    } catch (error) {
      console.error("Error fetching cameras from API:", error);
      this.setState({ cameras: [], loading: false }); // Clear the cameras list in case of error
    }
  };

  handleSiteSelection = (siteId, siteInfo) => {
    this.setState({ selectedSite: siteId, selectedSiteInfo: siteInfo });
    this.getDevicesListById(siteId);
  };
  

  handleChangePage = (newPage) => {
    this.setState({ currentPage: newPage });
  };

  handleSearchInputChange = (e) => {
    this.setState({ searchInput: e.target.value });
  };



  // Handler to toggle dropdown table for a device row // we will use this to load cameras of device
  handleRowClick = async (deviceId) => {
    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
    console.log("--------auth tocken---------", access_tocken);
    let headers = {
      'content-type': 'application/json',
      'Authorization': `Bearer ${access_tocken}`
    }

    let device_details = await get(urls.DEVICE_DETAILS(deviceId), headers)

    console.log("handleRowClick---device_camera_Details", device_details)

    this.setState({
      device_details: device_details?.data?.[0] || [""]
    })


    this.setState(
      (prevState) => ({
        expandedRow: prevState.expandedRow === deviceId ? null : deviceId, // Toggle the row
      }),
      () => {
        if (this.state.expandedRow) {
          this.getCamerasList(deviceId); // Fetch data only when the row is expanded
        }
      }
    );
    // this.getCamerasList(deviceId);
  };


  update_operator_rating = async (rating) => {
    console.log("update_operator_rating called with:", rating);

    let update_data = {
      operator_rating: rating,
    };

    console.log("Update data being sent:", update_data);
    // Update operatorRating used in Show More
    this.setState({ operator_rating: rating });

    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_tocken}`
      }
      let response = await post(urls.OPERATOR_RATING(this.state.selectedCamera.id), JSON.stringify(update_data), headers);
      console.log("Response received:", response);

      if (response !== false) {
        console.log("Operator rating updated successfully.");
        // Optionally update the state or provide feedback to the user here
        this.setState({
          selectedCamera: {
            ...this.state.selectedCamera,
            operator_rating: rating,
          },
        });

        // updating table column value immediately after rating update
          const updatedTable = this.state.cameras?.map(cam => {
            if (cam.id === this.state.selectedCamera.id) {
              return { ...cam, operator_rating: rating };
            }
            return cam;
          });

          this.setState({ cameras: updatedTable });
        //
        // this.SpecificCameraSync(this.state.selectedCamera.id); // Sync specific camera after rating update
        this.openSnackbar("Operator rating updated successfully! Please reload to view updated rating.", "success");
      } else {
        console.error("Failed to update operator rating.");
        this.openSnackbar("Error occured while rating the image.", "error");

      }
    } catch (error) {
      console.error("Error while updating operator rating:", error);
    }
  };

  handleCameraRowClick = async (camera) => {
    this.setState(
      (prevState) => ({
        nestedExpandedRow: prevState.nestedExpandedRow === camera.id ? null : camera.id, // Toggle the row
        selectedCamera: camera,
        refreshSystemOverviewstatuscard: !prevState.refreshSystemOverviewstatuscard,
      }),

    );
    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
    console.log("--------auth tocken---------", access_tocken);
    let headers = {
      'content-type': 'application/json',
      'Authorization': `Bearer ${access_tocken}`
    };
    // this.setState({ selectedCamera: camera });
    console.log("cam :- ", camera);
    // fetch cam details for camera id = camera 
    // let response = await get(urls.CAMERA_DETAILS(camera.id), headers)
    // console.log("response CAMERA_DETAILS :- ", response)

    // Fetching FPS Info
    await this.fetchCameraFPS(camera.id);

    // fetch ref_img img and latest_img img captured by shedule/backend  
    let res_for_img_info = await get(urls.CAMERA_LATEST_IMAGES(camera.id), headers);
    console.log("res2 :", res_for_img_info.data.length);
    console.log("res2 handleCameraRowClick--:", res_for_img_info);

    if (!res_for_img_info.data || res_for_img_info.data.length === 0) {
      console.error("No image data available");
      return;
    }

    // Process images based on capture type
    if (res_for_img_info.data.length === 1) {

      const image = res_for_img_info.data[0];
      
      console.log("image",image)

      if (image.capture_type === "ref_img") {
        this.setState({
          // ref_img_created_time: image.description,
          ref_img_id: image.id,
        });
        this.set_images("ref_img", image.id);
      } else if (image.capture_type === "latest_img") {
        this.setState({
          latest_img_taken_at: image.description,
        });
        this.set_images("latest_img", image.id);
      }
    } 
      else if (res_for_img_info.data.length === 2) {
        let refImg = res_for_img_info.data.find((img) => img.capture_type === "ref_img");
        console.log("ref_img", refImg.id);
        let latestImg = res_for_img_info.data.find((img) => img.capture_type === "latest_img");
    
        if (refImg) {
          this.setState({
            ref_img_created_time: refImg.description,
            ref_img_id: refImg.id,
          });
          // this.set_images("ref_img", refImg.id);
        }
    
        if (latestImg) {
          this.setState({
            latest_img_taken_at: latestImg.description,
          });
          // this.set_images("latest_img", latestImg.id);
        }
      }
    //   console.log("State updated successfully");

    
  }

  fetchCameraFPS = async (cameraId) => {
  try {
    const username = "admin";
    const password = "neudeep@1";

    // Encode "username:password" to Base64
    const basicAuth = btoa(`${username}:${password}`);
    let headers = {
      "content-type": "application/json",
      "Authorization": `Basic ${basicAuth}`
    };

    let fpsResponse = await get(urls.GET_CAMERA_FPS(cameraId), headers);

    console.log("FPS Data:", fpsResponse);
    
    this.setState({
      cameraFPSInfo: fpsResponse || null
    });

  } catch (error) {
    console.error("Error fetching FPS info:", error);
  }
  };


  // set_images = async (type, img_id) => {
  //   try {
  //     let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
  //     console.log("--------auth tocken---------", access_tocken);

  //     const response = await axios.get(urls.SERVE_REFERENCE_IMAGE(img_id), {
  //       responseType: "blob", // Ensures the response is treated as binary data
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //         'Authorization': `Bearer ${access_tocken}`
  //       },
  //     });

  //     // Create an object URL from the blob
  //     const imageURL = URL.createObjectURL(response.data);

  //     // Update the state with the image blob
  //     this.setState({
  //       capturedImageBlob: response.data, // Store blob for uploading
  //     });

  //     if (type === 'ref_img') {
  //       // Update the state with the new image URL
  //       this.setState((prevState) => ({
  //         selectedCamera: {
  //           ...prevState.selectedCamera,
  //           image1: imageURL,
  //         },
  //       }));
  //     }
  //     else {
  //       // Update the state with the new image URL
  //       this.setState((prevState) => ({
  //         selectedCamera: {
  //           ...prevState.selectedCamera,
  //           image2: imageURL,
  //         },
  //       }));
  //       // Convert Blob to Data URL
  //     //   const reader = new FileReader();
  //     //   reader.readAsDataURL(response.data);
  //     //   reader.onloadend = () => {
  //     //     const base64DataURL = reader.result; // Get base64 string
  //     //     this.setState({ imageURL: base64DataURL }, () => {
  //     //       this.setImageAsCanvas(imageURL); // Set background image
  //     //     });        
  //     // }
  //   }
  //     // console.log("Snapshot fetched and set:", imageURL);
  //     //console.log("Snapshot fetched and set:", imageURL);
  //   } catch (error) {
  //     console.error("Error fetching snapshot:", error);
  //   }
  // }

  // Toggle collapsible function
  handleToggle = (section) => {
    this.setState((prevState) => ({
      activeSection: prevState.activeSection === section ? null : section,
    }));
  };

  openSnackbar = (msg, alert_type = 'warning' || 'success' || 'error' || 'info') => {
    this.setState({
      open_snackbar: true,
      snackbar_msg: msg,
      alert_type: alert_type,
    })
  }

  // set 
  // Function to fetch the snapshot and set it as the camera image
  capture_snapshot = async () => {
    const {selectedCamera} = this.state
    if (this.state.is_rtsp_device === true){ 
      let data = {
        "camera_id" : selectedCamera.id,
      }
      console.log("Request payload for rtsp snapshot capture:", data);
      try{
          this.startLoading();
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
          // let headers = {
          //       'content-Type': 'application/json',
          //       'Authorization': `Bearer ${access_tocken}`,
          //     };
          // const response = await post(urls.CAPTURE_RTSP_SNAPSHOT, JSON.stringify(data), headers);
          const response = await axios.post(
            urls.CAPTURE_RTSP_SNAPSHOT, // API URL
            data, // Payload (data object)
            {
              responseType: "blob", // Ensures the response is treated as binary data
              headers: {
                "Content-Type": "multipart/form-data",
                'Authorization': `Bearer ${access_tocken}`
              }
            }

          );
          this.stopLoading();
          console.log("CAPTURE_RTSP_SNAPSHOT", response);
          if(response.status == 200){
            this.setState({ currentTime_of_device: this.getCurrentTimeInDeviceTimezone(this.state.devices.site_timezone), ref_img_created_time: this.getCurrentTimeInDeviceTimezone(this.state.devices.site_timezone) })
            console.log("is_rtsp_device group time setting FormData:", this.getCurrentTimeInDeviceTimezone(this.state.devices.site_timezone));
            
            // Create an object URL from the blob
            const imageURL = URL.createObjectURL(response.data);

            // Update the state with the image blob
            this.setState({
              capturedImageBlob: response.data, // Store blob for uploading
              // ref_img_created_time: currentTime,
            });


          // Update the state with the new image URL
          this.setState((prevState) => ({
            selectedCamera: {
              ...prevState.selectedCamera,
              image1: imageURL,
            },
          }));
          
          console.log("Snapshot fetched and set:", imageURL);
          //alert("Reference image captured successfully!");
          this.openSnackbar("Reference image through RTSP camera captured successfully!", 'success');
        }else{
          this.openSnackbar("Failed to capture the reference image through RTSP camera. Please try again.", 'error');
        }
      }catch(error){
        console.error("Error capturing RTSP snapshot:", error);
        this.openSnackbar("Error capturing RTSP snapshot", 'error');
      }
      
    }
    else {
    console.log("Device info:", this.state.device_details);
    let data = {
      ip_address: this.state.device_details.ip_address,
      protocol: this.state.device_details.protocol?.toLowerCase().replace('://', ''), // Convert to lowercase and remove '://'
      port_number: String(this.state.device_details.port_number), // Ensure port_number is a string
      device_username: this.state.device_details.device_username,
      device_password: this.state.device_details.device_password,
      channel_id: String(this.state.selectedCamera.channel_id), // Ensure channel_id is a string
    };

    console.log("Request payload:", data);

    try {
      this.startLoading();
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      const response = await axios.post(
        urls.SNAPSHOT_BY_DATA, // API URL
        data, // Payload (data object)
        {
          responseType: "blob", // Ensures the response is treated as binary data
          headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${access_tocken}`
          }
        }

      );
      this.stopLoading();

      // Access the custom header from the response
      console.log("Response headers:", response.headers);
      const currentTime = response.headers["x-current-time"];
      console.log("Current Time from API:", currentTime);
      // this.setState({ currentTime_of_device: currentTime })
      
      this.setState({ currentTime_of_device: currentTime, ref_img_created_time: currentTime  })

      // Create an object URL from the blob
      const imageURL = URL.createObjectURL(response.data);

      // Update the state with the image blob
      this.setState({
        capturedImageBlob: response.data, // Store blob for uploading
      });


      // Update the state with the new image URL
      this.setState((prevState) => ({
        selectedCamera: {
          ...prevState.selectedCamera,
          image1: imageURL,
        },
      }));
      
      console.log("Snapshot fetched and set:", imageURL);
      //alert("Reference image captured successfully!");
      this.openSnackbar("Reference image captured successfully!", 'success')
    } catch (error) {
      console.error("Error fetching snapshot:", error);
      this.openSnackbar("Failed to capture the reference image. Please try again.", 'error');
    }
  };
}


  // Function to save the captured snapshot as a reference image
  save_reference_image = async () => {
    const { selectedCamera, capturedImageBlob } = this.state;

    if (!selectedCamera || !capturedImageBlob) {
      console.error("Camera ID or captured image is missing!");
      this.openSnackbar("Captured image is missing, please try again!", 'error');
      return;
    }

    if (this.state.is_rtsp_device === true){
      this.startLoading();
      let data = {
        "camera_id" : selectedCamera.id,
      };
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
      let headers = {
            'content-Type': 'application/json',
            'Authorization': `Bearer ${access_tocken}`
            };
      let response = await post(urls.SAVE_RTSP_CAMERA_SNAPSHOT, JSON.stringify(data), headers);
      console.log("save_reference_image RTSP", response);
      this.stopLoading();
      if (response.data != null){
        this.openSnackbar("Reference image for this RTSP camera saved successfully!", 'success');
        this.setState({
          ref_img_created_time: response.data.description,//response.data.created_at,
        });
      }else {
        this.openSnackbar("Failed to save Reference image for this RTSP camera", 'error');
        console.error(response.error[0])
      }
            
    }else{
      try {
        // Prepare FormData for API request
        this.startLoading();
        let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
        const formData = new FormData();
        formData.append("camera", selectedCamera.id); // Ensure camera ID is passed
        formData.append("image", capturedImageBlob, "snapshot.jpg"); // Attach image blob
        formData.append("capture_type", "ref_img"); // Optional description
        // if (this.state.is_rtsp_device === true){
        //   formData.append("description", this.getCurrentTimeInDeviceTimezone(this.state.devices.site_timezone));
        //   console.log("is_rtsp_device group time setting FormData:", this.getCurrentTimeInDeviceTimezone(this.state.devices.site_timezone));
        // } else{
        formData.append("description", this.state.currentTime_of_device);
        // }; // Attach current timestamp
        console.log("Sending FormData:");
        for (let [key, value] of formData.entries()) {
          console.log(key, value);
        }

        const response = await axios.post(urls.REFERENCE_IMAGE_LIST, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${access_tocken}`
          },
        });

          this.stopLoading();
          this.openSnackbar("Reference image saved successfully!", 'success');
          this.setState({
          ref_img_created_time: response.data.description,//response.data.created_at,
        });
        // if (this.state.is_rtsp_device === true){
        //   // formData.append("description", this.getCurrentTimeInDeviceTimezone(this.state.devices.site_timezone));
        //     this.setState({ ref_img_created_time: this.getCurrentTimeInDeviceTimezone(this.state.devices.site_timezone) })
        //   console.log("is_rtsp_device group time setting FormData:", this.getCurrentTimeInDeviceTimezone(this.state.devices.site_timezone));
        // } else{
        // this.setState({ ref_img_created_time: response.data.description, })
        // };
        // setTimeout(() => {
        //    window.location.reload();
        //   // this.handleRowClick(this.state.Selected_Device_Id);
        // }, 3000); // 3 seconds delay

      } catch (error) {
          // Handle error
          this.setState({
            errorMessage: "Failed to save reference image. Please try again.",
          });
          console.error("Error saving reference image:", error);
          this.stopLoading();
          this.openSnackbar("Failed to save reference image. Please try again.!", 'error');
      }
    }
  };

  capture_Latest_Img_snapshot_Manually = async () => {
    console.log("Device info in Latest_Img_snapshot:", this.state.device_details);

    let data = {
      ip_address: this.state.device_details.ip_address,
      protocol: this.state.device_details.protocol?.toLowerCase().replace('://', ''),
      port_number: String(this.state.device_details.port_number),
      device_username: this.state.device_details.device_username,
      device_password: this.state.device_details.device_password,
      channel_id: String(this.state.selectedCamera.channel_id),
    };

    console.log("Request payload in Latest_Img_snapshot:", data);

    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
      this.startLoading();
      const response = await axios.post(
        urls.SNAPSHOT_BY_DATA,
        data,
        {
          responseType: "blob",
          headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${access_tocken}`,
          },
        }
      );
      this.stopLoading();



      const currentTime = response.headers["x-current-time"] || new Date().toISOString();
      console.log("All headers in capture_latest_image:", response.headers);
      console.log("x-current-time capture_latest_image:", response.headers["x-current-time"]);
      const imageURL = URL.createObjectURL(response.data);

      // Sequentially update state variables
      await new Promise((resolve) => {
        this.setState(
          {
            capturedLatestImageBlob: response.data, // Store blob for uploading
            latest_img_taken_at: currentTime,
            selectedCamera: {
              ...this.state.selectedCamera,
              image2: imageURL,
              latest_img_taken_at: currentTime,
            },
            
          },
          resolve // Ensure state is updated before proceeding
        );
      });
      

      console.log("Snapshot in Latest_Img_snapshot fetched and set:", imageURL, currentTime);
      this.openSnackbar("Latest image captured successfully!", 'success');

      // Now safely call the save function
      await this.save_Manually_captured_Latest_image();
    } catch (error) {
      console.error("Error fetching snapshot:", error);
      this.openSnackbar("Failed to capture the latest image. Please try again.", 'error');
    }
  };

  save_Manually_captured_Latest_image = async () => {
    const { selectedCamera, capturedLatestImageBlob, latest_img_taken_at } = this.state;

    if (!selectedCamera || !capturedLatestImageBlob) {
      console.error("Camera ID or captured image is missing!");
      return;
    }

    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
      const formData = new FormData();
      formData.append("camera", selectedCamera.id);
      formData.append("image", capturedLatestImageBlob, "snapshot.jpg");
      formData.append("capture_type", "latest_img");
      formData.append("description", latest_img_taken_at);

      console.log("Sending FormData:", formData);
      const readableFormData = {};
      formData.forEach((value, key) => {
        readableFormData[key] = value;
      });

      console.log("Readable FormData:", readableFormData);

      const response = await axios.post(urls.REFERENCE_IMAGE_LIST, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          'Authorization': `Bearer ${access_tocken}`,
        },
      });

      console.log("Latest image saved response:", response.data);
      
    } catch (error) {
      this.setState({
        errorMessage: "Failed to save reference/latest image. Please try again.",
      });
      console.error("Error saving reference/latest image:", error);
    }
  };


  handleDeleteCamera = async (selected_camera_id) => {    //to delete RTSP cameras only.

    const userConfirmed = window.confirm('Are you sure you want to remove this camera?');

    if (!userConfirmed) {
      return; // If the user clicks "Cancel" in the confirmation dialog, abort the delete operation
    }

    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      const url = urls.DEVICE_DETAILS(selected_camera_id);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'content-Type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`,
        },

      });
      console.log("reponse in delete elevator ------------->", response);
      if (response.ok) {

        //   console.log("reponse.ok ------------->", response.ok);

        // const data =  response.json(); 
        console.log(`Elevator with id ${selected_camera_id} deleted successfully`, response);
        // window.location.reload();
        this.getCamerasList(selected_camera_id);
      }
      else {
        const errorMessage = response.statusText; // Read the error message from response body
        alert(`Failed to delete user with ID ${selected_camera_id}: ${errorMessage}`);

      }
    } catch (error) {
      console.error('Error during delete request:', error);
    }

  }

  openDialog = () => {
    this.setState({
      confirmDialog: {
        isOpen: true,
        title: 'Confirm Action',
        subtitle: "Are you sure, you want to save the new reference image? This will overwrite the existing image.",
      },
    });
  };

    openDeleteDialog = () => {
    this.setState({
      confirmDeleteDialog: {
        isOpen: true,
        title: 'Confirm Action',
        subtitle: "Are you sure, you want to remove this camera from the system?",
      },
    });
  };

  closeDialog = () => {
    this.setState({
      confirmDialog: {
        ...this.state.confirmDialog,
        ...this.state.confirmDeleteDialog,
        isOpen: false,
      },
    });
  };


  handleCameraSchedule = (deviceId) => {
    console.log("handleCameraSchedule---cameraId---", deviceId)
    localStorage.setItem(globalVariables.DEVICE_ID, deviceId);
    //navigate to system-manager/scheduler by navigation
    this.props.navigate("/system-overview/scheduler");
  }


  toggleMuteUnmuteDIalogue = (CameraId) => {
    this.setState({
      open_MuteUnmute_Dialogue : true,
      selectedCameraId: CameraId // Store the selected camera ID in state
    });
    console.log("selected cam id---toggleMuteUnmuteDIalogue-----",CameraId );
  }

  handleMuteUnmuteCameraNotifications = async (CameraId) => {
    console.log("selected cam id---handleMuteUnmuteCameraNotifications-----", CameraId);
    const{mute, cameras } = this.state
    // console.log("selectedCameraId-----", selectedCameraId);

    let data = {
      "mute": mute,
    }
    let post_data = JSON.stringify(data)
    console.log("data---MuteUnmute----", post_data);


    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      // console.log("--------auth tocken---------", access_tocken);
      let headers = {
        // 'content-type': 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${access_tocken}`
      }
      // Call custom get method
     let  url = urls.CAMERA_NOTIFICATIONS_MUTE_UNMUTE(CameraId)
      console.log("url---MuteUnmute----", url);

      let response1 = await post(urls.CAMERA_NOTIFICATIONS_MUTE_UNMUTE(CameraId), post_data, headers)
      console.log('res-------->', response1);
      
      if (response1) {
      

      if (response1.data.length !== 0) {
        const updatedCameras = cameras.map(camera => {
        if (camera.id === CameraId) {
          return { ...camera, mute }; // update mute status in the array
        }
        return camera;
      });
      this.setState({
        // muteResponseMessage: response1.message,
        success2: true,
        cameras: updatedCameras,
      });
    }
      else if (response1.error.length > 0){
        
        this.setState({
        muteResponseMessage: response1.error[0] || "Server error! Try again later.",
        error2: true,
        // cameras: updatedCameras,
      });
      // return

      }
      // ✅ Delay for 1.5 seconds before calling cameraSync
      await new Promise(resolve => setTimeout(resolve, 3000));
      // this.cameraSync()
      // this.LoadSelectedDeviceInfo(this.state.Selected_Device_Id);
      this.SpecificCameraSync(CameraId); // Sync only the specific camera that was muted/unmuted

    }
    }
    catch (error) {
      console.error('Error:', error);
    }

  }

  // Method to handle modal close
  handleCloseModal = () => {
    const { Selected_Device_Id } = this.state;
    this.setState({ 
      open_MuteUnmute_Dialogue: false, 
      selectedCameraId: null, 
      success2:false, 
      success: false }, () => {
      // this.cameraSync()
      console.log("-----close mute modal----");
    });
 
  }; //let response = await get(urls.CAMERA_DETAILS(camera.id), headers)
    // console.log("response CAMERA_DETAILS :- ", response)

  SpecificCameraSync = async (selectedCameraId) => {
    // const { muteResponseMessage } = this.state;
    this.setState({muteResponseMessage: "", error2 :false})
    console.log("-----SpecificcameraSync----selectedCameraId----", selectedCameraId);
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_tocken}`
      }
      const url = urls.CAMERA_DETAILS(selectedCameraId);  
      const response = await get(url, headers); // Perform the API call using the constructed URL
      console.log(`API Response for SpecificcameraSync ${selectedCameraId}:`, response);
      if (response && Object.keys(response).length > 0) {
        console.log(`API Response for SpecificcameraSync ${selectedCameraId}:`, response);
        
        this.setState(prevState => ({
          cameras: prevState.cameras.map(cam =>
            cam.id === selectedCameraId
              ? { ...cam, mute: response.mute, ignore_zones: response.ignore_zones, Camera_report_mute: response.camera_health_mute  === "True"? true : false }
              : cam
          ),
          selectedCamera: response,
          open_MuteUnmute_Dialogue: false,
          open_CameraHealth_MuteUnmute_Dialogue: false,
          success2: false,
          success: false
        }));
        this.getCameraMuteUnmuteCount(); // Fetch the updated mute/unmute status for the specific camera
        this.openSnackbar("Cameras synced successfully!", 'success');
      }
      else {
        console.error("No valid data returned from the get-camera API");
        this.openSnackbar("Failed to update camera notifications. Please try again.", 'error');
      }
    } catch (error) {
      console.error("Error fetching cameras from API:", error);
      this.openSnackbar("Failed to update camera notifications. Please try again.", 'error');
    }
  }

   

  getCameraMuteUnmuteCount = async () => {
    const{Selected_Device_Id}=this.state
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
      let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_tocken}`
      };
      const url = urls.GET_MUTE_UNMUTE_CAMERAS_COUNT_PER_DEVICE(Selected_Device_Id);
      const response = await get(url, headers);
      console.log(`API Response for getCameraMuteUnmuteCount ${Selected_Device_Id}:`, response);
      if (response && response.data) {
        this.setState({
          CameraHealthMuteCount: response.data.camera_health_mute_count,
          VideoAnalysisUnmuteCount: response.data.unmute_count,
          CameraHealthUnmuteCount: response.data.camera_health_unmute_count,
          IsCameraHealthScheduleSet: response.data.camera_health_schedule,

        });
      }
    }
    catch (error) {
      console.error("Error fetching camera mute/unmute count:", error);
    }
  }
    


  getCurrentTimeInDeviceTimezone = (timezone ) => {
    try {
      // Get the current time in the specified timezone
      const localTime = new Intl.DateTimeFormat("en-US", {
          timeZone: timezone,
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true, // Use 12-hour format
      }).format(new Date());
        

      return localTime;
    } catch (error) {
        console.error("Error calculating device time:", error);
        return "Error calculating time";
    }
};

  formatToUSDateTime = (datetimeStr) => {
    if (!datetimeStr || typeof datetimeStr !== "string" || !datetimeStr.includes(",")) {
      console.warn("Invalid datetime string:", datetimeStr);
      return "Invalid Date";
    }
    // console.log("device time received,", datetimeStr);
    // input: "11/04/2025,07:22" (DD/MM/YYYY, 24hr format)
    const [datePart, timePart] = datetimeStr.split(",");
    const [day, month, year] = datePart.split("/");

    const [hour, minute] = timePart.split(":");
    const date = new Date(`${year}-${month}-${day}T${hour}:${minute}`);

    return new Intl.DateTimeFormat("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(date); // returns: "04/11/2025, 7:22 AM"
  }

// getCurrentTimeInPosixTz = (posixTz) => {
//   try {
//       if (!posixTz) return "-";

//       // Convert POSIX to IANA timezone (e.g., EST5EDT -> America/Detroit)
//       const ianaTimezone = "America/Detroit"; // Manually mapping for accuracy

//       // Get the current time in that timezone
//       const dt = DateTime.now().setZone(ianaTimezone);

//       // Format: "7/2/2025 at 08:30 AM"
//       const formattedTime = dt.toFormat("MM/dd/yyyy',' hh:mm a");

//       return formattedTime;
//   } catch (error) {
//       console.error("Error calculating time:", error);
//       return "Error calculating time";
//     }
// };

  handleUnmuteAlert = () => {
    this.setState({
      success: true
    });

  }

  deleteReferenceImage = async () => { 
    if (this.state.is_rtsp_device === true){
      const {selectedCamera} = this.state
      let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem(globalVariables.AUTH_TOKEN)}`
      }

      let response = await del(urls.DELETE_RTSP_REF_IMAGE_SNAPSHOT(selectedCamera.id), headers);
      console.log("----deleteReferenceImage RTSP----res----", response);
      // if (response.data.message === "RTSP preview deleted successfully") {
      if (response) {
        this.openSnackbar("Reference image deleted successfully!", 'success');
        setTimeout(() => {
             window.location.reload();
            // this.handleRowClick(this.state.Selected_Device_Id);
          }, 3000); // 3 seconds delay
      }else{
        this.openSnackbar("Failed to delete reference image. Please try again.", 'error');
      }
    }
    else {
    try {
      const { ref_img_id } = this.state
      let url = (urls.REFERENCE_IMAGE_DETAIL(ref_img_id))
      console.log("---deleteReferenceImage--url---------", url);
      let response = await del(urls.REFERENCE_IMAGE_DETAIL(ref_img_id))
      // let response = await del(urls.REFERENCE_IMAGE_DETAIL(0))
      console.log("----deleteReferenceImage----res----", response);
      if (response) {
        this.openSnackbar("Reference image deleted successfully!", 'success');
          setTimeout(() => {
             window.location.reload();
            // this.handleRowClick(this.state.Selected_Device_Id);
          }, 3000); // 3 seconds delay
      }
      else if (response && response.error === "Reference image not found") {
        this.openSnackbar("Reference image not found!", "error");
      } else if (response === false) {
        this.openSnackbar("Failed to delete reference image. Reference image not found.", "error");
      } else {
        this.openSnackbar("An unexpected error occurred.", "error");
      }
    } catch (error) {
      console.error("Delete Error:", error);
      this.openSnackbar("Failed to delete reference image. Please try again.", "error");

    }
  }
  }



  // ---------------------------Add Site Functions---------------------------------------------------------
  
      handleInputChange = (e) => {
          const { name, value } = e.target;
          this.setState({ [name]: value }, () => {
            this.validateField(name, value);
          });
      };
  
      
  
      startLoading = () => {
          console.log("startloading")
      
          this.setState({ open_progress_bar: true })
      }
      
      stopLoading = () => {
          this.setState({ open_progress_bar: false })
      }

      
  //-------------------------------------------------------------------------------------------------------
 //------------------ get device info----------------------------------------------------------------------
   LoadSelectedDeviceInfo = async () => {
    //  this.setState({ editToggle: true });
    console.log("--------deviceId---------", this.state.Selected_Device_Id);
     try {
       let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
       console.log("--------auth tocken---------", access_tocken);
       let headers = {
           'content-type': 'application/json',
           'Authorization': `Bearer ${access_tocken}`
       }
       const url = urls.DEVICE_DETAILS(this.state.Selected_Device_Id);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
       const response = await get(url, headers); // Perform the API call using the constructed URL
       console.log(`API Response for LoadSelectedDeviceInfo ${this.state.Selected_Device_Id}:`, response);
 
       if (response && Object.keys(response).length > 0) {
         console.log(`API Response for LoadSelectedDeviceInfo ${this.state.Selected_Device_Id}:`, response);
         let deviceInfo = response.data[0];
         this.setState({ 
          devices: deviceInfo,
          cloudStorageStatusMap: deviceInfo.cloudstorage_status === "False" ? false : true,
          //-----for edit device form storing the values in respective state variables
          EditDeviceName: deviceInfo.device_name || "",
          EditDeviceType: deviceInfo.device_type || "",
          EditIpAddress: deviceInfo.ip_address || "",
          EditRTSPAddress: deviceInfo.rtsp_port || "",
          EditProtocol: deviceInfo.protocol || "",
          EditPortNumber: deviceInfo.port_number || "",
          EditDeviceUsername: deviceInfo.device_username || "",
          EditDevicePassword: deviceInfo.device_password || "",
          client : deviceInfo.client || "",
          deviceStatusMap : deviceInfo.device_status === "inactive" ? false : true,
          CameraHealthMuteCount : deviceInfo.camera_health_mute_count,
          VideoAnalysisUnmuteCount : deviceInfo.unmute_count,
          CameraHealthUnmuteCount : deviceInfo.camera_health_unmute_count,
          IsCameraHealthScheduleSet : deviceInfo.camera_health_schedule,
          });
          if (response.data[0].arm_disarm_status === "armed" || response.data[0].arm_disarm_status === "disarmed") {
            this.setState({ isDeviceArmed: response.data[0].arm_disarm_status === "armed" });
            console.warn("response.data[0].arm_disarm_status:", response.data[0].arm_disarm_status);
          } else {
            console.warn("⚠️ Unexpected response:", response);
          }
 
       } else {
         console.error("No valid data returned from the get-camera API");
       }

       this.handleRowClick(this.state.Selected_Device_Id);

     } catch (error) {
       console.error("Error fetching cameras from API:", error);
     }
   };

   //--------------------------------------------------------------------------------------------

   //------------Template Update----------------------------------------------------------------

   handleTemplateUpdate = () => {
    this.setState({templateEditToggle : true});
     this.handleFetchTemplate();
   }

   closeTemplateUpdate = () => {
    this.setState({templateEditToggle : false});
   }

   handleFetchTemplate = async() => {
   
      try{
          let response = await get(urls.HEALTH_RECORDING_POLICY);
          console.log("FetchTemplate API Response:", response)
          if (response) {
              console.log("res",response)
              this.setState({ template_list: response.data });
          } else {
              console.error("No data returned from the API");
              this.setState({ template_list: [] });
          }
      }

      catch (error) {
          console.error("Error fetching devices from API:", error);
      }
  }

  handleUpdateTemplate = async() => {
      const{ template_name, Selected_Device_Id} = this.state;
      // Validation for required fields
      if (!template_name) {
          this.setState({ warning: true });
          setTimeout(() => {
            this.setState({warning:false});
          }, 4500);
          return;
      }
        let post_data = {
                  "device_ids" : [Selected_Device_Id],
                  "recording_policy_id" : template_name,
              }
      
              post_data = JSON.stringify(post_data);
              console.log("------post-data in SaveTemplate---", post_data);
      
              try{
                  let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
                  console.log("--------auth tocken---------", access_tocken);
                  let headers = {
                      // 'content-type': 'application/json',
                      'Content-Type': 'application/json; charset=UTF-8',
                      'Authorization': `Bearer ${access_tocken}`
                  }
                  let response = await post(urls.SET_TEMPLATE_TO_MULTIPLE_DEVICES, post_data, headers);
                  console.log("API Response:", response)
                  if(response && response.error==="device_ids and recording_policy_id are required."){
                      // this.setState({ warning: true});
                      this.openSnackbar("device_ids and recording_policy_id are required.", 'warning')

                      console.log("res",response);
                  }else if (response && response.error!=="device_ids and recording_policy_id are required.") {
                      // this.setState({ success: true, Responsemessage: response.message });
                      this.openSnackbar("New Recording policy template is applied successfully!", 'success')
                      setTimeout(() => {
                          window.location.reload();
                      }, 3500); // 3 seconds delay

                  }
                    else {
                      console.error("No response returned from the API");
                      this.openSnackbar("Server Error!", 'success')
                      // this.setState({ error: true });
                      // setTimeout(() => {
                      //     window.location.reload();
                      // }, 3000); // 3 seconds delay
                  }
              }
      
              catch (error) {
                  console.error("Error fetching devices from API:", error);
              }
  }

  cameraSync = () => {
    const{Selected_Device_Id}=this.state
    this.setState({ open_MuteUnmute_Dialogue: false })
    console.log("-----cameraSync----Selected_Device_Id", Selected_Device_Id);
    this.startLoading();
    // Delay for alert visibility before reload
    // this.handleRowClick(Selected_Device_Id);
    // this.stopLoading();
    //  this.syncSelectedDevice();

    setTimeout(() => {
      this.getCamerasList(Selected_Device_Id).then(() => {
          this.stopLoading(); // Stop loading after cameras are fetched
      });
  }, 200); // Ensures progress bar is visible before stopping
  }
       

  // --------------------ignore zone draw img -------------------
  

  //-------------------------------------------------------------------------------

  toggleIgnoreZoneSection = async (cameraId) => {
    console.log("toggleIgnoreZoneSection called with cameraId:", cameraId);
    this.setState({toggleIgnoreZone:true});
    let post_data = {
      "camera_id": cameraId,
      "send_image_path": true
    }
    post_data = JSON.stringify(post_data);
    console.log("toggleIgnoreZone post_data for getting image path from media:", post_data);
    try{
      this.startLoading();
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          console.log("--------auth tocken---------", access_tocken);
          let headers = {
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': `Bearer ${access_tocken}`
          }
          let response = await post(urls.LATEST_IMAGE_PATH_FROM_MEDIA_FOLDER, post_data, headers);
          console.log("API Response:", response)
          
          this.setState({latest_image_path: response.data.local_media_url});
          localStorage.setItem(globalVariables.LATEST_IMAGE_PATH, response.data.local_media_url);
          this.stopLoading();
    }
    catch {
      console.error("Error fetching latest image path from media folder");
       this.stopLoading();
    }
  }

  closeIgnoreZoneSection = async (cameraId) => {
    console.log("closeIgnoreZoneSection called with cameraId:", cameraId);
    this.setState({toggleIgnoreZone:false});
    let post_data = {
      "camera_id": cameraId,
      "send_image_path": false,
    }
    post_data = JSON.stringify(post_data);
    console.log("closeIgnoreZone post_data for removing image path from media folder:", post_data);
    try{
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          console.log("--------auth tocken---------", access_tocken);
          let headers = {
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': `Bearer ${access_tocken}`
          }
          let response = await post(urls.LATEST_IMAGE_PATH_FROM_MEDIA_FOLDER, post_data, headers);
          console.log("API Response:", response)
    }
    catch {

    }
  }

  getHDDColor = (totalFreeSpace, totalSpace) => { //new func to show color based on addition of free space of all hdd
    if (!totalFreeSpace && !totalSpace) return "black"; // Default color in case of missing data
  
    // const [used, total] = storage.split("/").map(value => parseFloat(value));
    if (isNaN(totalFreeSpace) || isNaN(totalSpace) || totalSpace === 0) return "black"; // Handle edge cases
  
    const usedPercentage = (totalFreeSpace / totalSpace) * 100;
  
    return usedPercentage < 80 ? "#38d27b" : "#fe4a4a"; // Green if < 80%, Red if ≥ 80%  totalFreeSpace, totalSpace
  };

  toggleDetails = (deviceId) => { //state change to show all hdd data onclick of 'i' icon
    this.setState((prevState) => ({
      showDiskDetails: {
        ...prevState.showDiskDetails,
        [deviceId]: !prevState.showDiskDetails[deviceId], // Toggle for specific row
      },
    }));
  };

  toggleDeviceUserList = (device) => { //state change to show all hdd data onclick of 'i' icon

    console.log("--toggleDeviceUserList popup----");
    // this.setState({showDeviceUserList: true});
    this.setState({
      showDeviceUserList: true,
      selectedDeviceForUserList: device, // <- Save selected device
    });
  };

  handleCloseUserListModal = () => {
    this.setState({ showDeviceUserList:false }, () => {
      console.log("-----close user list modal----");
    });
 
  };

  // Toggle Arm DisArm
  toggleDeviceArmedStatus = () => {
  this.setState((prevState) => ({
    isDeviceArmed: !prevState.isDeviceArmed
  }));
}

//Arm Disarm status Logic
// fetchArmStatus = async () => {
//   console.log("🚨 fetchArmStatus CALLED");

//   try {
//     const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
//     const headers = {
//       'Content-Type': 'application/json; charset=UTF-8',
//       'Authorization': `Bearer ${access_token}`,
//     };

//     const deviceId = this.state.deviceIdForArmDisarm;

//     if (!deviceId) {
//       console.warn("❗ deviceIdForArmDisarm not set");
//       return;
//     }

//     const url = urls.GET_DEVICE_ARM_STATUS(deviceId);
//     console.log("🌐 Fetching Arm Status from:", url);

//     const response = await get(url, headers);
//     console.log("✅ GET Arm Status Response:", response);

//     if (response?.arm_disarm_status === 'armed' || response?.arm_disarm_status === 'disarmed') {
//       this.setState({ isDeviceArmed: response.arm_disarm_status === 'armed' });
//     } else {
//       console.warn("⚠️ Unexpected response:", response);
//     }

//   } catch (error) {
//     console.error("❌ Error fetching arm status:", error);
//   }
// };

  fetchVAScheduleData = async (deviceId) => {
    // const deviceId = this.state.Selected_Device_Id;
    const token = localStorage.getItem(globalVariables.AUTH_TOKEN);

    if (!deviceId) {
      console.error("Device ID is missing.");
      return;
    }

    try {
      const response = await fetch(urls.GET_ALERT_SCHEDULES(deviceId), {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });

      console.log("Response: fetchVAScheduleData", response);

      if (!response.ok) {
        console.error("Failed to fetch VA schedule:", response.status);
        this.setState({ error_fetching: true });
        return;
      }

      const result = await response.json();
      const { data } = result;

      const vaSelectedBlocks = [];

      data.forEach(schedule => {
        const { start_time, end_time, days, alert_schedule_id } = schedule;
        const dayList = days.split(",").map(day => day.trim()).filter(Boolean);

        const startHour = parseInt(start_time.split(":")[0], 10);
        let endHour = parseInt(end_time.split(":")[0], 10);
        let endMinute = parseInt(end_time.split(":")[1], 10);
        if (endMinute > 0) {
          endHour += 1; // Include this hour if end minute is not 00
        }

        for (let hour = startHour; hour < endHour; hour++) {
          if (hour >= 24) break; 
                // const timeLabel = this.convertTo12HourFormat(`${hour.toString().padStart(2, '0')}:00`);
                const timeLabel = `${hour.toString().padStart(2, '0')}:00`;
                dayList.forEach(day => {
                  const fullDay = this.getFullDayName(day);
                  vaSelectedBlocks.push({ day: fullDay, time: timeLabel, id: alert_schedule_id });
                });
        }
      });

      this.setState({ vaSelectedBlocks }, () => {
        console.log("Selected Blocks for UI:", this.state.vaSelectedBlocks);
      });

      // flag to check full day (24 hr) schedule availability in any day of the week -------

      const dayCoverage = {}; // e.g. { Monday: 24, Tuesday: 12, ... }
      vaSelectedBlocks.forEach(block => {
        if (!dayCoverage[block.day]) dayCoverage[block.day] = new Set();
        dayCoverage[block.day].add(block.time);
      });

      // ✅ Get today's day name (e.g. "Monday", "Tuesday", etc.)
      const today = new Date();
      const todayName = today.toLocaleDateString("en-US", { weekday: "long" });

      // ✅ Check if today has full 24-hour coverage
      const hasFullDay = dayCoverage[todayName] && dayCoverage[todayName].size === 24;  //checking only for today's full day schedule availability.
      // const hasFullDay = Object.values(dayCoverage).some(set => set.size === 24);  //previously checking if any day of the week has 24hrs schedule

      localStorage.setItem("HAS_FULL_DAY_SCHEDULE", hasFullDay ? "true" : "false");
      //--------------------------------------------------------------------------------------

    } catch (error) {
      console.error("Error fetching VA schedule data:", error);
      this.setState({ error_fetching: true });
    }
  };

updateArmStatus = async (status) => {
  // const device_id = this.state.deviceIdForArmDisarm;
  const device_id =this.state.Selected_Device_Id  //used the selected device id from state as the device_id for arm/disarm status bz now deviceIdForArmDisarm is not getting set anywhere

  if (!device_id || (status !== 'armed' && status !== 'disarmed')) {
    console.error("❌ Invalid payload:", { device_id, status });
    return;
  }

  // Checking if there is a 24-hour VA schedule and user is disarming:---------
  const hasFullDaySchedule = localStorage.getItem("HAS_FULL_DAY_SCHEDULE") === "true";
  if (hasFullDaySchedule && status === 'disarmed') {
    this.setState({
      manualDisarmMessage: "Disarming manually will not automatically arm this device again.",
      showManualDisarmAlert: true,
    });

    // Optional: Auto-hide alert after few seconds
    setTimeout(() => {
      this.setState({ showManualDisarmAlert: false });
    }, 3000);
  }
  //--------------------------------------------------------------------------
  // ⏳ Set loading direction: 'arming' or 'disarming'
  this.setState((prevState) => ({
    armDisarmLoading: true,
    armDisarmAction: status === "armed" ? "arming" : "disarming", // 👈 add this
    showArmDialog: false,
    armDisarmStatusByDevice: {
      ...prevState.armDisarmStatusByDevice,
      [device_id]: status === 'armed' ? 'arming' : 'disarming',
    }
  }));

  const post_data = JSON.stringify({ device_id, status });

  if(status === 'armed' || status === 'disarmed'){
    this.setState({ ShowarmStatusMessage: true})
  }

  try {
    const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
    const headers = {
      'Content-Type': 'application/json; charset=UTF-8',
      'Authorization': `Bearer ${access_token}`,
    };

    const response = await post(urls.POST_DEVICE_ARM_STATUS, post_data, headers);
    // const response = await post(urls.abc);
    console.log("✅ Arm/Disarm API Response:", response);

    if(response.message === "Server capacity full. Cannot arm device now." || response.utilization_percent ===  100.0 ) {
      this.setState({
      isDeviceArmed: status === 'disarmed',
      armDisarmLoading: false, // ✅ Remove loading icon
    });
    this.openSnackbar('Server capacity full. Cannot arm device now.', 'error');
    }
    else if(response.message === "Server capacity could not be verified — please try again later." || response.utilization_percent ===  "unknown" ) {
      this.setState({
      isDeviceArmed: status === 'disarmed',
      armDisarmLoading: false, // ✅ Remove loading icon
    });
    this.openSnackbar('Server capacity could not be verified — please try again later.', 'error');
    }
    else if(response.error === "Device is offline or not responding. Cannot ARM.") {
      this.setState({
      isDeviceArmed: status === 'disarmed',
      armDisarmLoading: false, // ✅ Remove loading icon
    });
    this.openSnackbar('Device is offline or not responding. Cannot ARM.', 'error');
    }
    else {
    // this.openSnackbar(`server utilization percentage is ${response.utilization_percent}`, 'success');
    // 🎯 Success: handle both ARM and DISARM cases clearly
    // this.setState({ ShowarmStatusMessage: true}) //show msg:`Site is manually ${status}ing... It will take 5 mins to reflect the changes.`,

    if (status === "armed") {
      const successMessage = `Site is armed... Server utilization: ${response.utilization_percent}%`;
      this.openSnackbar(successMessage, "success");
    } else {
      // When disarming, avoid showing an empty snackbar.
      // If you want a disarm confirmation message, set it explicitly here:
      // this.openSnackbar('Site disarmed successfully.', 'success');
    }

    this.setState({
      isDeviceArmed: status === 'armed',
      armDisarmLoading: false, // ✅ Remove loading icon
      ShowarmStatusMessage: false
    });
  }
  } catch (error) {
    console.error("❌ Failed to update arm/disarm status:", error);
    this.setState({ armDisarmLoading: false });
  }
};


fetchDeviceStatus = async () => {
  const { Selected_Device_Id } = this.state;
  const token = localStorage.getItem(globalVariables.AUTH_TOKEN);
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };
  // const body = JSON.stringify({ device_id: this.state.Selected_Device_Id });
  
    try {
      const url = `${urls.GET_DEVICE_STATUS(Selected_Device_Id)}`; // Construct the URL using the static method
      console.log("url for device Status: ",url);
      const res = await get(url, headers);
      const status = res?.device_status?.toLowerCase(); // normalize for consistency
      console.log("Response for device Status: ",res);

      const isActive = status === "active"; // set true or false
      this.setState({ deviceStatusMap: isActive }); // affects switch checked state
    } catch (error) {
      console.error("Error fetching device status for site_id:", error);
       // fallback to `true` if API fails
      this.setState({ deviceStatusMap : true });    }
  
  
};

handleToggleDeviceStatus = async (deviceId, newStatus) => {
  const token   = localStorage.getItem(globalVariables.AUTH_TOKEN);
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };
  const statusString = newStatus ? "active" : "inactive";
  const body = JSON.stringify({ device_id: deviceId, device_status: statusString });
  console.log("Response for toggling device status:", body);
  try {
    const res = await post(urls.DEVICE_STATUS, body, headers);
    console.log("Response for toggling device status:", res);
    // Update local map first so UI reacts immediately
    // this.setState(
    //   (prev) => ({
    //     deviceStatusMap: newStatus ,
    //   }),
    //   () => {
    //     if (newStatus) {
    //       // user just re‑enabled -> fetch fresh device list
    //       this.fetchDeviceStatus(); // ✅ fetch fresh status
    //     }
    //   }
    // );
    this.setState({ deviceStatusMap: newStatus });

    this.openSnackbar(
      `Device is now ${newStatus ? 'Active' : 'Inactive'}.`,
      'success'
    );
    setTimeout(() => {
      this.LoadSelectedDeviceInfo(); //  fetch fresh device status (manually updated) after toggle
    }, 2000); // 2 seconds delay to allow user to see the toggle effect before refreshing status
  } catch (err) {
    console.error('Toggle failed', err);
    this.openSnackbar('Failed to update device status.', 'error');
  }
};

ActionLogs= () => {
    
    localStorage.setItem(globalVariables.DeviceActionLogs, this.state.Selected_Device_Id);
    this.props.navigate("/device-action-logs");
}

handleCloudStatusToggle = async (cameraId) => {
  const currentStatus = this.state.cameraCloudStatus[cameraId] || false;
  const newStatus = !currentStatus;

  const cameraCloudValue = newStatus ? "True" : "False"; // Capitalized string

  // 🔍 Log the intent
  console.log(
    `🔁 Toggling cloud storage for Camera ID: ${cameraId} | New Status: ${cameraCloudValue}`
  );

  const token = localStorage.getItem(globalVariables.AUTH_TOKEN);
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };

  const body = JSON.stringify({
    camera_id: cameraId.toString(),
    camera_cloudstorage: cameraCloudValue,
  });

  try {
    const url = urls.UPDATE_CAMERA_CLOUD_STORAGE;
    console.log("📡 Request URL:", url);
    console.log("📦 Payload being sent:", body);

    const res = await post(url, body, headers);
    console.log("✅ Response from update API:", res);

    if (res?.message === "Camera cloud storage updated successfully.") {
      this.setState((prevState) => ({
        cameraCloudStatus: {
          ...prevState.cameraCloudStatus,
          [cameraId]: newStatus,
        },
      }));

      // ✅ Show message based on toggle status
      const statusMessage = newStatus
        ? "Cloud storage enabled successfully."
        : "Cloud storage disabled successfully.";
      this.openSnackbar(statusMessage, "success");

    } else {
      this.openSnackbar("Unexpected response while updating cloud storage.", "warning");
    }

  } catch (error) {
    console.error("❌ Error while updating camera cloud storage:", error);
    this.openSnackbar("Failed to update cloud storage.", "error");
  }
};

getCloudStorageTemplates = async() => {
  const userId = localStorage.getItem(globalVariables.USER_ID);
  const accessToken = localStorage.getItem(globalVariables.AUTH_TOKEN);
  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    };
    let response = await get(urls.GET_DEALER_SPECIFIC_CLOUD_STORAGE_TEMPLATES_WITH_DETAILS(userId), headers);
    console.log("dealer specific Cloud Storage Templates Response:", response);     
    if(response && response.length > 0){
      this.setState({ storage_templates_list: response || [] });
    }
  }
  catch(error){
    console.error("Error fetching cloud storage templates:", error);
  }
}

setCloudStorageTemplate = async() => {
  const { storage_template_name, Selected_Device_Id, numberOfDays } = this.state;
  const userId = localStorage.getItem(globalVariables.USER_ID);
  if(!storage_template_name || !numberOfDays){
    this.openSnackbar("Please fill all the required fields.", 'warning');
    return;
  }
  let post_data = {
    "device_id": Selected_Device_Id,
    "template": storage_template_name,
    "no_of_days": numberOfDays,
    "user" : userId
  }

  post_data = JSON.stringify(post_data);
  console.log("post_data for setting cloud storage template:", post_data);
  const accessToken = localStorage.getItem(globalVariables.AUTH_TOKEN);
  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    };
    let response = await post(urls.SET_STORAGE_TEMPLATE_TO_DEVICE, post_data, headers);
    console.log("setCloudStorageTemplate API Response:", response);
    if(response && response.message && response.message?.includes("Successfully")){
      
      this.openSnackbar("Cloud storage template set successfully!", 'success');
      setTimeout(async() => {
        this.setState({ showCloudEditModal: false });
        // await this.getAppliedStorageTemplateForDevice(Selected_Device_Id);
        await this.cameraSync()
      }, 2000); // 2 seconds delay
    }
    else if(response && response.error){
      this.openSnackbar("Failed to set cloud storage template. Please try again.", 'error');
    }

  }catch (error) {
    console.error("Error setting cloud storage template:", error);
  }

}

// /api/Device/update_cloudstorage_status/ cloudstorage_status
setCamerasCloudStorageStatusOnToggle = async(newStatus) => {
  const { storage_template_name, Selected_Device_Id, numberOfDays, cloudStorageStatusMap } = this.state;
  // const userId = localStorage.getItem(globalVariables.USER_ID);
  // if(!storage_template_name || !numberOfDays){
  //   this.openSnackbar("Please set the cloud storage template.", 'warning');
  //   return;
  // }
  this.setState({ cloudStorageStatusMap: newStatus });
  let booleanToStringCloudStatus = newStatus ? "True" : "False";  
  let post_data = {
    "device_id": Selected_Device_Id,
    "cloudstorage_status": booleanToStringCloudStatus,
  }

  post_data = JSON.stringify(post_data);
  console.log("post_data for setting cloud storage template:", post_data);
  const accessToken = localStorage.getItem(globalVariables.AUTH_TOKEN);
  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    };
    let response = await post(urls.SET_ALL_CAMERAS_CLOUD_STORAGE_STATUS_ON_TOGGLE, post_data, headers);
    console.log("setCloudStorageTemplate API Response:", response);
    if(response && response.message && response.message?.includes("Cloud storage status updated successfully")){
      
      this.openSnackbar("Cloud storage is successfully activated for all cameras!", 'success');
      setTimeout(async() => {
        // this.setState({ showCloudEditModal: false });
        await this.getCamerasList(Selected_Device_Id, 1);
      }, 2000); // 2 seconds delay
    }
    else if(response && response.error){
      this.openSnackbar("Failed to perform the action. Please try again.", 'error');
    }

  }catch (error) {
    console.error("Error setting cloud storage template:", error);
  }

}

fetchCameraCloudStatus = async (cameraId) => {
  const token = localStorage.getItem(globalVariables.AUTH_TOKEN);
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };

  try {
    const url = urls.GET_CAMERA_CLOUD_STORAGE(cameraId);
    console.log("📡 Fetching cloud storage status from:", url);

    const res = await get(url, headers);
    console.log("✅ Response from GET camera cloud status API:", res);

    const rawStatus = res?.camera_cloudstorage?.toString().toLowerCase(); // e.g. "true", "false"
    const isEnabled = rawStatus === "true";

    // ✅ Update individual camera status in state
    this.setState((prevState) => ({
      cameraCloudStatus: {
        ...prevState.cameraCloudStatus,
        [cameraId]: isEnabled,
      },
    }));

  } catch (error) {
    console.error(`❌ Failed to fetch cloud storage for Camera ID ${cameraId}:`, error);
    // fallback to disabled
    this.setState((prevState) => ({
      cameraCloudStatus: {
        ...prevState.cameraCloudStatus,
        [cameraId]: false,
      },
    }));
    this.openSnackbar("Failed to load cloud storage status.", "error");
  }
};

getAppliedStorageTemplateForDevice = async (Selected_Device_Id) => {
  const token = localStorage.getItem(globalVariables.AUTH_TOKEN);
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };

  try {
    // let url = urls.GET_APPLIED_CLOUD_STORAGE_TEMPLATE_TO_DEVICE(Selected_Device_Id);
    // console.log("--------url-applied storage template ", url);
    let requestData = await get(urls.GET_APPLIED_CLOUD_STORAGE_TEMPLATE_TO_DEVICE(Selected_Device_Id), headers);
    console.log("Applied Storage Template Response:", requestData);
    if (requestData && typeof requestData === 'object' && requestData.template) {
      this.setState({
        applied_storage_template: requestData.template ,
        applied_days_for_storage: requestData.no_of_days ,
      });
    }
    else {
      this.setState({
        applied_storage_template: "",
        applied_days_for_storage: "",
      });
      console.warn("Invalid or incomplete or No applied storage template found for this device.");
    }

  }catch (error) {
    console.error("Error fetching applied storage template for device:", error);
    this.openSnackbar("Failed to load applied storage template.", "error");
  }
}

getRecordingPolicyTemplateForDevice = async (Selected_Device_Id) => {
  const token = localStorage.getItem(globalVariables.AUTH_TOKEN);
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };

  try {
    let url = urls.GET_HEALTH_RECORDING_POLICY_BY_DEVICE(Selected_Device_Id);
    console.log("--------url-applied recording template ", url);
    let requestData = await get(urls.GET_HEALTH_RECORDING_POLICY_BY_DEVICE(Selected_Device_Id), headers);
    console.log("Applied recording Template Response:", requestData);
    // if (requestData && typeof requestData === 'object' && requestData.template) {
    //   this.setState({
    //     applied_storage_template: requestData.template ,
    //     applied_days_for_storage: requestData.no_of_days ,
    //   });
    // }
    // else {
    //   this.setState({
    //     applied_storage_template: "",
    //     applied_days_for_storage: "",
    //   });
    //   console.warn("Invalid or incomplete or No applied storage template found for this device.");
    // }

  }catch (error) {
    console.error("Error fetching applied storage template for device:", error);
    this.openSnackbar("Failed to load applied storage template.", "error");
  }
}

handleMouseEnter = (event, camera) => {     //function to show camera image preview on hover of camera name
  const imageUrl = camera.latest_image_url || null;
  const latest_img_time = camera?.latest_image_timestamp || null;
  console.log("handleMouseEnter called for camera latest_image_timestamp:", camera.camera_name, "with latest_image_timestamp:", latest_img_time);
  if (!imageUrl) return;

  const rect = event.currentTarget.getBoundingClientRect();
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const previewWidth = 220; // hover box width
  const previewHeight = 140; // hover box height

  // Default: show on right, aligned with top of row
  let x = rect.right + 5;
  let y = rect.top + window.scrollY;

  // If it overflows on the right → show on left
  if (x + previewWidth > viewportWidth) {
    x = rect.left - previewWidth - 10;
  }

  // If it overflows on the left → center above
  if (x < 0) {
    x = rect.left + rect.width / 2 - previewWidth / 2;
  }

  // Check vertical overflow (bottom of viewport)
  const spaceBelow = viewportHeight - rect.bottom;
  const spaceAbove = rect.top;

  // If not enough space below, move it above the row
  if (spaceBelow < previewHeight + 20 && spaceAbove > previewHeight + 20) {
    y = rect.top + window.scrollY - previewHeight - 5;
  } else {
    y = rect.bottom + window.scrollY; // otherwise show just below row
  }

  // Prevent it from going above the top of the screen
  if (y < window.scrollY) {
    y = rect.top + window.scrollY + 5;
  }

  this.setState({
    hoveredCameraImage: imageUrl,
    hoveredCameraImageTimestamp: latest_img_time,
    hoverPosition: { x, y },
  });
};



  handleMouseLeave = () => {
    this.setState({ hoveredCameraImage: null, hoveredCameraImageTimestamp: null });
  };

  handleCameraInfoSubmission = async (e) => {
    e.preventDefault();
    this.startLoading();
    console.log("----handleCameraInfoSubmission-----------");
    const { CameraName, rtspStreamParameter, Selected_Device_Id } = this.state;
    
    // Prepare payload
    let cameraData = {
        camera_name: CameraName,
        rtsp_path: rtspStreamParameter, // Example RTSP URL format
        };
    const data = JSON.stringify(cameraData);
    console.log("----camera-data to be sent---", data);

    if (!CameraName || !rtspStreamParameter) {
        this.setState({ warning_camera: true});
        this.stopLoading();
        return;
    }

    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
          let headers = {
              // 'content-type': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': `Bearer ${access_tocken}`
          }
          
          let response = await post(urls.ADD_CAMERA(Selected_Device_Id), data, headers);
          this.stopLoading();
          // console.log("url",urls.ADD_CAMERA);
          console.log("data res",response);
          if(response.data?.message === "Camera added successfully and snapshot triggered.") {
            this.setState({ success_camera: true });
            setTimeout(() => {
              this.setState({ toggleAddSingleCamera: false });
              // this.getCamerasList(Selected_Device_Id);
              this.LoadSelectedDeviceInfo(Selected_Device_Id);
              this.getCamerasList(Selected_Device_Id);
            }, 2000);
          }
          else if (response.error && Array.isArray(response.error)) {

          const errorMsg = response.error[0];

          this.setState({
            error_camera: true,
            success_camera: false,
            warning_camera: false,
            error_camera_message: errorMsg
          });

        }
          else {
            this.setState({ error_camera: true });
          }
    } catch (error) {
      this.setState({ error_camera: true });
    }
  }

  closePopup = () => {
    this.setState({ toggleAddSingleCamera: false, editCameraToggle: false, editDeviceToggle: false  });
  };

  handleCameraKebabClick = (event, camera) => {
    this.setState({ anchorE2: event.currentTarget, selectedCamera: camera, selectedCameraId: camera.id  });
  };

  handleClose = () => {
    this.setState({ anchorE2: null, open1: false });
  };

  LoadSelectedCameraInfo = async (cameraId) => {
    this.setState({anchorE2: null, editCameraToggle: true });
    // this.setState({camera_Id : cameraId});
    console.log("--------cameraId cameraId---------", cameraId);

    try {
      this.startLoading();
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`
      }
      const url = urls.GET_SELECTED_CAMERA_INFO(cameraId);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
      let response = await get(url, headers); // Perform the API call using the constructed URL
      console.log(`API Response for LoadSelectedCameraInfo ${cameraId}:`, response);
      this.stopLoading();
      response = response.data;
      if (response && Object.keys(response).length > 0) {
        console.log(`API Response for LoadSelectedCameraInfo ${cameraId}:`, response, response.rtsp_parameter);
        this.setState({ 
          EditCameraName: response.camera_name || "",
          // EditDeviceType: response.device_type || "",
          // EditIpAddress: response.ip_address || "",
          EditRTSPAddress: response.rtsp_parameter || "",
          // EditProtocol: response.protocol || "",
          // EditPortNumber: response.port_number || "",
          // EditDeviceUsername: response.device_username || "",
          // EditDevicePassword: response.device_password || "",
          // client : response.client || "",
          });

      } else {
        console.error("No valid data returned from the get-camera API");
        // this.setState({ cameras: [] }); // Ensure cameras list is cleared for invalid data
      }
    } catch (error) {
      console.error("Error fetching cameras from API:", error);
      // this.setState({ cameras: [] }); // Clear the cameras list in case of error
    }
  };

  handleSaveCameraEditedInfo =  async (selected_camera_id) => {

    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

      let data = {
        "camera_name": this.state.EditCameraName,
        
        "rtsp_url": this.state.EditRTSPAddress,
            
      }
      console.log("-----JSON DATA -------->",data);
      let post_data = JSON.stringify(data);

      if (!this.state.EditCameraName || !this.state.EditRTSPAddress) {
        this.setState({ warning_camera_edit: true});
        this.stopLoading()
        return;
    }
      
      try {
        const url = urls.UPDATE_SELECTED_CAMERA_INFO(selected_camera_id);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
        const response = await fetch(url, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json', // Specify the content type
            'Authorization': `Bearer ${access_tocken}` // Optional: If your API requires an authorization token
          },
          body: post_data,
          
        });
        console.log("reponse in edit device info ------------->", response);
        if (response.ok) {

        //   console.log("reponse.ok ------------->", response.ok);
          this.setState({success_camera_edit: true});

          // Delay before reload to allow user to see the alert
          setTimeout(() => {
            // window.location.reload();
            this.setState({ editCameraToggle: false });
            this.getCamerasList(this.state.Selected_Device_Id);
            // this.setState({ editCameraToggle: false });
            // this.LoadSelectedCameraInfo (selected_camera_id);
        }, 2000); // 3 seconds delay
          } 
        else {
        this.setState({error_camera_edit: true});

        }
      } catch (error) {
        console.error('Error during delete request:', error);
      }
    
  }

  handleCameraDelete =  async (selected_camera_id) => {      
      try {
        const {selectedCameraId} = this.state
        let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
        const url = urls.DELETE_RTSP_CAMERA(selectedCameraId);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
        console.log("reponse in delete device url ------------->", url);
        const response = await fetch(url, {
          method: 'DELETE',
          headers: {
            'content-Type': 'application/json',
            'Authorization': `Bearer ${access_tocken}`,
          },
          
        });
        console.log("reponse in delete rtsp camera ------------->", response);
        if (response.ok) {
        //   console.log("reponse.ok ------------->", response.ok);
 
          console.log(`camera with id ${selected_camera_id} deleted successfully`, response);
          this.openSnackbar("Camera deleted successfully!", 'success');
          
          setTimeout(() => {
            this.getCamerasList(this.state.Selected_Device_Id);
            this.LoadSelectedDeviceInfo(this.state.Selected_Device_Id);
        }, 2000); // 2 seconds delay
          } 
        else {
              this.openSnackbar("Error while deleting the camera, Try again!", 'error');
                 
        }
      } catch (error) {
        console.error('Error during delete request:', error);
      }
    
  }

  fetchDeviceTypes = async () => {
    try {
        let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
        console.log("--------auth tocken---------", access_tocken);
        let headers = {
            'content-type': 'application/json',
            'Authorization': `Bearer ${access_tocken}`
        }
        console.log("Fetching data from:", urls.DEVICE_TYPE_LIST);
        const response = await get(urls.DEVICE_TYPE_LIST, headers);
        console.log("Device types list Response in Adddevice-----:", response);

        if (!response || !Array.isArray(response)) {
            console.error("Invalid response format or empty list.");
            this.setState({ device_type_list: [] });
            return;
        }

        this.setState({ device_type_list: response }); // Directly use the array from your response
        console.log("Updated state with device types list:", this.state.device_type_list);
    } catch (error) {
        console.error("Error in fetchDeviceTypes:", error);
        this.setState({ device_type_list: [] });
    }
  }
  

    handleSaveDeviceEditedInfo =  async (selected_device_id) => {
      const {
          EditDeviceName,
          EditDeviceType,
          EditIpAddress,
          EditProtocol, 
          EditPortNumber,
          EditDeviceUsername,
          EditDevicePassword,
          EditRTSPAddress, errors} = this.state;

          // BLOCK SAVE if validation errors exist
        if (errors && Object.keys(errors).length > 0) {
          this.setState({ warning_device: true });
          return;
        }
        
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
  
        let data = {
          "device_name": EditDeviceName,
          "device_type": EditDeviceType,
          "client" : this.state.client,
          "ip_address": EditIpAddress,
          "rtsp_port": EditRTSPAddress,
          "protocol": EditProtocol,
          "port_number": EditPortNumber,
          "device_username": EditDeviceUsername,
          "device_password": EditDevicePassword    
        }
        console.log("-----JSON DATA -------->",data);
        let post_data = JSON.stringify(data);

        // if (!this.state.EditDeviceName || !this.state.EditDeviceUsername || !this.state.EditIpAddress || !this.state.EditDevicePassword) {
        //   this.setState({ warning_device: true});
        //   this.stopLoading()
        //   return;
        // }
        if (EditProtocol === "rtsp"){
        let requiredDeviceData = [
          EditDeviceName,
          // EditDeviceType,
          EditIpAddress,
          EditProtocol, 
          EditPortNumber,
          EditDeviceUsername,
          EditDevicePassword,
          EditRTSPAddress,
      ];
      
      if (requiredDeviceData.some(field => !String(field ?? "").trim())) { //optimised conditional check for empty fields
        this.setState({ warning_device: true });
        this.stopLoading();
        return;
      }
    } else {
      let requiredDeviceData = [
          EditDeviceName,
          EditDeviceType,
          EditIpAddress,
          EditProtocol, 
          EditPortNumber,
          EditDeviceUsername,
          EditDevicePassword,
          EditRTSPAddress,
      ];
      
      if (requiredDeviceData.some(field => !String(field ?? "").trim())) { //optimised conditional check for empty fields
        this.setState({ warning_device: true });
        this.stopLoading();
        return;
      }
    }
        
        try {
          const url = urls.DEVICE_DETAILS(selected_device_id);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
          const response = await fetch(url, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json', // Specify the content type
              'Authorization': `Bearer ${access_tocken}` // Optional: If your API requires an authorization token
            },
            body: post_data,
            
          });
          console.log("reponse in edit device info ------------->", response);
          const result = await response.json(); 
          if (response.ok) {
  
          //   console.log("reponse.ok ------------->", response.ok);
            this.setState({success_device_edit: true});
  
            // Delay before reload to allow user to see the alert
            setTimeout(() => {
              window.location.reload();
              // this.setState({editDeviceToggle: false});
              
              
          }, 3000); // 1 seconds delay
            } 
          else {
            this.setState({error_device_edit: true, responseMessage: result?.error?.[0]});
          }
        } catch (error) {
          this.setState({error_device_edit: true, responseMessage: "Server error! Device was not updated."});
          this.stopLoading();
          console.error('Error during delete request:', error);
        }
    }

  togglePasswordVisiblity = () => {
  this.setState(prevState => ({
    passwordShown: !prevState.passwordShown
  }));
  };

  openEditDeviceModal = () => {
    this.setState({anchorE1: null, editDeviceToggle: true });
      // this.setState({Selected_Device_Id : deviceId});
  }

  handleDeviceKebabClick = (event) => {
    this.setState({ anchorE1: event.currentTarget });
  };

  normalizeDuration = (input) => {
    if (!input) return "";

    let hours = 0;
    let minutes = 0;

    const hourMatch = input.match(/(\d+)\s*hour/);
    const minMatch = input.match(/(\d+)\s*min/);

    if (hourMatch) hours = parseInt(hourMatch[1], 10);
    if (minMatch) minutes = parseInt(minMatch[1], 10);

    const days = Math.floor(hours / 24);
    const remainingHours = hours % 24;

    const parts = [];
    if (days) parts.push(`${days} day${days > 1 ? "s" : ""}`);
    if (remainingHours) parts.push(`${remainingHours} hour${remainingHours > 1 ? "s" : ""}`);
    // 🔴 Explicitly handle 0 min
    if (minutes > 0 || parts.length === 0) {
      parts.push(`${minutes} min`);
    }
    // if (minutes) parts.push(`${minutes} min`);

    return parts.join(" ");
  }

  convertScheduleToDateTime = (scheduleStr) => {  //function to convert the next schedule day and time to date and time
    const [dayStr, timeStr] = scheduleStr.split(" ");
    const [hours, minutes, seconds] = timeStr.split(":").map(Number);

    const daysMap = {
      Sunday: 0,
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6,
    };

    const targetDay = daysMap[dayStr];
    const now = new Date();
    const todayDay = now.getDay();

    let daysToAdd = targetDay - todayDay;
    if (daysToAdd < 0) daysToAdd += 7;

    const scheduledDate = new Date(now);
    scheduledDate.setDate(now.getDate() + daysToAdd);
    scheduledDate.setHours(hours, minutes, seconds || 0, 0);

    return scheduledDate.toLocaleString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  }

  validateField = (name, value) => {
  let errors = { ...this.state.errors };

  const noSpaceFields = [
    "ipAddress", "rtsp_port", "portNumber",
    "EditIpAddress", "EditRTSPAddress", "EditPortNumber", "rtspStreamParameter", "EditRtspStreamParameter", "devicePassword", "EditDevicePassword"
  ];

  const ipFields = ["ipAddress", "EditIpAddress"];
  const rtspFields = ["rtsp_port", "EditRTSPAddress"];
  const portFields = ["portNumber", "EditPortNumber"];
  const streamParamFields = ["rtspStreamParameter", "EditRtspStreamParameter"];

  // ❌ No spaces allowed for certain fields
  if (noSpaceFields.includes(name) && /\s/.test(value)) {
    errors[name] = "No spaces are allowed.";
    this.setState({ errors });
    return;
  }

  // ✅ Validate IP / DDNS
  if (ipFields.includes(name)) {
    if (!value) {
      errors[name] = "IP Address is required.";
    } else {
      const ipv4Regex = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|(([0-9a-fA-F]{1,4}:){1,7}:)|(([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4})|(([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2})|(([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3})|(([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4})|(([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5})|([0-9a-fA-F]{1,4}:)((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;
      const hostnameRegex = /^(?!:\/\/)(?=.{1,253}$)([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

      if (!(ipv4Regex.test(value) || ipv6Regex.test(value) || hostnameRegex.test(value))) {
        errors[name] = "Enter a valid IPv4, IPv6, or DDNS address.";
      } else {
        delete errors[name];
      }
    }
  }

  // ✅ Validate RTSP Port
  if (rtspFields.includes(name)) {
    if (!value) {
      errors[name] = "RTSP Port is required.";
    } else {
      const port = Number(value);
      if (!/^[0-9]{1,5}$/.test(value) || port < 1 || port > 65535) {
        errors[name] = "Enter a valid port number (1–65535).";
      } else {
        delete errors[name];
      }
    }
  }

  // ✅ Validate Server Port
  if (portFields.includes(name)) {
    if (!value) {
      errors[name] = "HTTP Port Number is required.";
    } else {
      const port = Number(value);
      if (!/^[0-9]{1,5}$/.test(value) || port < 1 || port > 65535) {
        errors[name] = "Enter a valid port number (1–65535).";
      } else {
        delete errors[name];
      }
    }
  }

  // ✅ Validate Stream Parameter
  if (streamParamFields.includes(name)) {
    if (!value) {
      errors[name] = "Stream parameter is required.";
    } else {
      const streamParamRegex = /^\/[a-zA-Z0-9_\-/.]+$/;
      if (!streamParamRegex.test(value)) {
        errors[name] = "Invalid format. Must start with '/' and contain only letters, numbers, '_', '-', '/', or '.'";
      } else {
        delete errors[name];
      }
    }
  }

  // For other fields → clear old errors
  if (![...noSpaceFields].includes(name)) {
    delete errors[name];
  }

  this.setState({ errors });
  };

  // camera health report mute/unmute functionality

  toggleCameraHealthMuteUnmuteDIalogue = (CameraId) => {
    
    this.setState({
      open_CameraHealth_MuteUnmute_Dialogue : true,
      selectedCameraId: CameraId // Store the selected camera ID in state
    });
    console.log("selected cam id---toggleCameraHealthMuteUnmuteDIalogue-----",CameraId );
  }

  handleCameraHealthMuteUnmuteReport = async (CameraId) => {
    console.log("selected cam id---handleMuteUnmuteCameraNotifications-----", CameraId);
    const{Camera_report_mute, cameras, devices, CameraHealthMuteCount, IsCameraHealthScheduleSet } = this.state;
    console.log("Camera_report_mute---handleMuteUnmuteCameraNotifications-----", Camera_report_mute, "devices.camera_health_mute_count", devices.camera_health_mute_count, "devices.cameras_count", devices.cameras_count, "devices.camera_health_schedule", devices.camera_health_schedule);
    if(Camera_report_mute === true && (CameraHealthMuteCount === devices.total_cameras - 1) && IsCameraHealthScheduleSet === true){
      this.openSnackbar("Please remove the schedule first then only you can mute all the cameras", "error");
      return;
    }
    
    let updatedMuteStatus = Camera_report_mute === true ? "True" : "False"; // Toggle the mute status

    let data = {
      "camera_health_mute": updatedMuteStatus,
    }
    let post_data = JSON.stringify(data)
    console.log("data---Camera_report_mute----", post_data);


    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      // console.log("--------auth tocken---------", access_tocken);
      let headers = {
        // 'content-type': 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${access_tocken}`
      }
      // Call custom get method
     let  url = urls.MUTE_UNMUTE_CAMERA_REPORT(CameraId)
      console.log("url---MuteUnmute----", url);

      let response1 = await post(urls.MUTE_UNMUTE_CAMERA_REPORT(CameraId), post_data, headers)
      console.log('res-------->', response1);
      
      if (response1) {
      if (response1.data.length !== 0) {
        const updatedCameras = cameras.map(camera => {
        if (camera.id === CameraId) {
          return {
            ...camera,
            camera_health_mute: updatedMuteStatus
          };
        }
        return camera;
      });
      this.setState({
        // muteResponseMessage: response1.message,
        success2: true,
        cameras: updatedCameras,
      });
    }else if (response1.error.length > 0){
        
      this.setState({
        // Camera_report_mute: true,
        muteResponseMessage: response1.error[0] || "Server error! Try again later.",
        error2: true,
        // cameras: updatedCameras,
      });
      // return;

    }
      // ✅ Delay for 1.5 seconds before calling cameraSync
      await new Promise(resolve => setTimeout(resolve, 2500));
      // this.cameraSync()
      // this.LoadSelectedDeviceInfo(this.state.Selected_Device_Id);
      this.SpecificCameraSync(CameraId); // Sync only the specific camera that was muted/unmuted

    }
    }
    catch (error) {
      console.error('Error:', error);
    }

  }

  render() {
    const { devices, cameras, loading, currentPage, rowsPerPage, searchInput, expandedRow, selectedCamera, activeSection, confirmDialog, open_MuteUnmute_Dialogue, error2, success2, nestedExpandedRow, confirmDeleteDialog, muteResponseMessage } = this.state;

    const {toggleAddSite, sitename, address, city, street, zip, state, organisationName, warning_site, success_site, error_site, client_list,
      selected_Customers , country, SiteName,  DeviceName, user_type, templateEditToggle, selectedCameraId, showDeviceUserList,selectedSite, camera_mute_status_sync} = this.state;

    // const { devices } = this.props;
    const { activeTab, template_list, template_name, toggleIgnoreZone, latest_image_path, storage_templates_list, storage_template_name, toggleAddSingleCamera, CameraName, rtspStreamParameter, warning_camera,
      error_camera, success_camera, is_rtsp_device, ShowarmStatusMessage, anchorE2, editCameraToggle, EditCameraName, EditRTSPAddress, error_camera_edit, success_camera_edit, warning_camera_edit,
      editDeviceToggle, Selected_Device_Id, EditDeviceName, EditDeviceType, EditProtocol, EditPortNumber, EditIpAddress, anchorE1,
      EditDeviceUsername, EditDevicePassword, success_device_edit, error_device_edit, passwordShown, global_alarm_status, password_visibility, device_type_list, warning_device, responseMessage, open_CameraHealth_MuteUnmute_Dialogue } = this.state;

    const CloudStorageStatus = localStorage.getItem(globalVariables.CLOUD_STORAGE_STATUS);
    

    // Ensure devices is an array
    // const filtered_Devices = (Array.isArray(devices) ? devices : []).filter((device) =>
    //   device.device_name?.toLowerCase().includes(searchInput?.toLowerCase() ?? "")
    // );

    // Ensure cameras is an array
    // const filteredCameras = (Array.isArray(cameras) ? cameras : []).filter((camera) =>
    //   camera.camera_name?.toLowerCase().includes(searchInput?.toLowerCase() ?? "")
    // );

    // const filtered_Sites = (Array.isArray(site_list) ? site_list : []).filter((site) =>
    //   site.sitename?.toLowerCase().includes(searchInput?.toLowerCase() ?? "")
    // );


    // Pagination logic
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    // const currentRows = filtered_Devices.slice(indexOfFirstRow, indexOfLastRow);
    // const currentSites = filtered_Sites.slice(indexOfFirstRow, indexOfLastRow);
    // const currentCamRows = filteredCameras.slice(indexOfFirstRow, indexOfLastRow);
    const isOnline = (selectedCamera?.status === 'online' || selectedCamera?.status === "videoOn" || selectedCamera?.status === "Recording" || selectedCamera?.status === "active");
    const isDeviceOffline = devices?.status === "inactive" || devices?.status === "offline";
    const selectedCam = cameras.find(cam => cam.id === selectedCameraId);
    const open1 = Boolean(anchorE2);
    const open2 = Boolean(anchorE1);
    // console.log("cameras ------>", cameras);

    return (
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <style>{`
          @media (max-width: 768px) {
            .about-device-page {
              min-height: 100vh;
              height: auto !important;
              overflow-x: hidden !important;
              overflow-y: auto !important;
            }

            .about-device-shell {
              margin-left: 58px !important;
              width: calc(100% - 58px);
              min-width: 0;
              transition: margin-left 0.3s ease, width 0.3s ease;
            }

            .navbar-container:not(.collapsed) ~ .about-device-shell {
              margin-left: 180px !important;
              width: calc(100% - 180px);
            }

            .about-device-breadcrumb {
              margin: 52px 12px 0 !important;
              width: calc(100% - 24px);
              height: auto !important;
              min-height: 40px;
            }

            .about-device-breadcrumb .MuiTableContainer-root {
              padding: 6px 10px !important;
            }

            .about-device-breadcrumb .MuiTypography-root {
              flex-wrap: wrap;
              row-gap: 4px;
              overflow-wrap: anywhere;
            }

            .about-device-breadcrumb .MuiAlert-root {
              width: 100%;
              margin-left: 0 !important;
            }

            .about-device-layout {
              margin-left: 0 !important;
              width: 100%;
              min-width: 0;
            }

            .about-device-content {
              width: 100%;
              height: auto !important;
              min-height: calc(100vh - 110px);
              padding: 12px !important;
              overflow-x: hidden;
              overflow-y: visible !important;
            }

            .about-device-tabs .MuiTabs-scroller {
              overflow-x: auto !important;
              scrollbar-width: thin;
            }

            .about-device-tabs .MuiTabs-flexContainer {
              width: max-content;
            }

            .about-device-tabs .MuiTab-root {
              flex: 0 0 auto;
              min-width: 145px;
              max-width: 210px;
              padding-left: 12px;
              padding-right: 12px;
            }

            .about-device-actions {
              justify-content: flex-start !important;
              align-items: center;
              flex-wrap: wrap;
              gap: 8px !important;
            }

            .about-device-actions .MuiButton-root {
              flex: 1 1 145px;
            }

            .about-device-content .MuiTableContainer-root {
              max-width: 100%;
              overflow-x: auto;
              -webkit-overflow-scrolling: touch;
            }

            .about-device-content .MuiTableContainer-root table {
              min-width: 700px;
            }

            .about-device-camera-heading {
              gap: 8px;
              flex-wrap: wrap;
              padding: 6px 8px;
            }

            .about-device-page .Slide-device-Add-form {
              width: 100% !important;
              max-width: 100vw;
              max-height: 100vh;
              overflow-y: auto;
            }

            .about-device-page .Slide-device-Add-form .form-section {
              width: 100%;
              max-width: 100%;
              box-sizing: border-box;
            }

            .about-device-page .Slide-device-Add-form input,
            .about-device-page .Slide-device-Add-form select,
            .about-device-page .Slide-device-Add-form textarea {
              width: 100% !important;
              max-width: 100%;
              box-sizing: border-box;
            }

            .about-device-page .form-group-device-edit {
              display: flex;
              flex-direction: column;
              align-items: stretch;
              gap: 4px;
            }

            .about-device-page .form-group-device-edit > div {
              width: 100% !important;
              max-width: 100%;
            }

            .about-device-page .modal-content,
            .about-device-page .modal-content-mute-unmute {
              width: calc(100vw - 24px) !important;
              max-width: calc(100vw - 24px);
              max-height: calc(100vh - 24px);
              overflow-y: auto;
              box-sizing: border-box;
            }
          }
        `}</style>
        <div className="about-device-page" style={{height:'100vh', overflow:'hidden'}}>
            {/* Global connectivity monitor */}
            <InternetConnectionDetector />
            {/* Navigation Bar */}
            <Navigationbar />
      
            <div className="about-device-shell" style={{ display: 'flex', flexDirection: 'column', marginLeft:'1.2%' }}>
        
            {/* Main Content with Flexbox Layout */}
            <Box
            className="about-device-breadcrumb"
            sx={{
                display: 'flex',
                marginLeft: '6.2%',
                marginRight:'2%',
                marginTop:'0.5%',
                
                height:'35px',
            }}>
                <TableContainer component={Paper} sx={{display: 'flex', height:'100%', alignItems:"center", paddingLeft:'10px'}}>
                <Typography variant="subtitle1" fontWeight="bold" display="flex" alignItems="center">
                   <Link to="/showDevices" style={{color:'#82b9f8'}}> Group</Link>  
                   <KeyboardArrowRightIcon fontSize="large" color="primary" />
                   <span
                     onClick={() => {
                      //  localStorage.setItem(globalVariables.SITE_ID, selectedSite);
                       localStorage.setItem(globalVariables.SITE_NAME, SiteName);
                       this.props.navigate("/deviceDetails");
                     }}
                     style={{ textDecoration: 'underline', color: '#82b9f8 ', cursor: 'pointer' }}
                   >
                     {SiteName}
                   </span>
                 <KeyboardArrowRightIcon fontSize="large" color="primary" /> {DeviceName}
                 {ShowarmStatusMessage && (
                  <Alert severity="info" sx={{ marginLeft: '20px' }}>
                    {/* {`Site is manually ${this.state.isDeviceArmed === 'armed' ? 'arming' : 'disarming'}... It will take up to 5 mins to reflect the changes.`} */}
                  {this.state.armDisarmLoading
                                    ? (
                                        (this.state.armDisarmAction === 'arming')
                                          ? `Device is manually arming. It may take up to 5 minutes for arm status to update.`
                                          : `Device is manually disarming. It may take up to 5 minutes for disarm status to update.`
                                      )
                                    : ""}
                  </Alert>
                 )}
                 {this.state.showManualDisarmAlert && (
                  <Alert severity="warning" sx={{ marginLeft: '20px' }}>
                    {this.state.manualDisarmMessage}
                  </Alert>
                 )}
                </Typography>
                </TableContainer>
            </Box>
            {/* Main  Content Layout */}
                <Box 
                className="about-device-layout"
                sx={{
                    display: 'flex',
                    marginLeft: '5%',
                   
                }}
                >
      
                {/* Main device Content Area */}
                <Box
                className="about-device-content"
                sx={{
                    flexGrow: 1, // Occupy remaining horizontal space
                    padding: '16px',
                    minWidth: 0, // Prevent content overflow
                    height: '88vh',
                    overflowY: 'scroll',
                    "&::WebkitScrollbar": {
                      width: "8px", // Adjust scrollbar thickness
                    },
                    "&::WebkitScrollbarThumb": {
                      backgroundColor: "#aaa", // Color of the scrollbar thumb
                      borderRadius: "4px", // Rounded corners for the thumb
                    },
                    "&::WebkitScrollbarThumb:hover": {
                      backgroundColor: "#888", // Color when hovered
                    },
                    scrollbarWidth: "1px", // Adjust scrollbar thickness in Firefox
                    scrollbarColor: "#aaa #f0f0f0",
                  }}
                >
                  {/* Subtab Bar */}
                  <Tabs
                    className="about-device-tabs"
                    value={activeTab}
                    onChange={this.handleTabChange}
                    indicatorColor="primary"
                    textColor="white"
                    variant="fullWidth"
                    component={Paper}
                  >
                    <Tab label="General Info" sx={{
                      backgroundColor: activeTab === 0 ? "#44576c" : "transparent",
                      color: activeTab === 0 ? "#ffffff" : "#a1a1a1",
                      fontWeight: activeTab === 0 ? 550 : 500
                    }} />
                    <Tab label="Scheduler" sx={{
                      backgroundColor: activeTab === 1 ? "#44576c" : "transparent",
                      color: activeTab === 1 ? "#ffffff" : "#a1a1a1",
                      fontWeight: activeTab === 1 ? 550 : 500
                    }}/>
                    {/* {!is_rtsp_device && ( */}
                    <Tab label="Recording Template" sx={{
                      display: is_rtsp_device ? "none" : "flex", // hide visually
                      backgroundColor: activeTab === 2 ? "#44576c" : "transparent",
                      color: activeTab === 2 ? "#ffffff" : "#a1a1a1",
                      fontWeight: activeTab === 2 ? 550 : 500
                    }}/> 
                    {/* )} */}
                    <Tab label="SMTP Alert" sx={{
                      backgroundColor: activeTab === 3 ? "#44576c" : "transparent",
                      color: activeTab === 3 ? "#ffffff" : "#a1a1a1",
                      fontWeight: activeTab === 3 ? 550 : 500,
                    }}/>
                    {devices.sms_service === true && (
                    <Tab label="SMS Notification" sx={{
                      backgroundColor: activeTab === 4 ? "#44576c" : "transparent",
                      color: activeTab === 4 ? "#ffffff" : "#a1a1a1",
                      fontWeight: activeTab === 4 ? 550 : 500,
                    }}/>
                    )}
                     {/* {CloudStorageStatus?.toLowerCase() === "true" && (
                      <Tab label="Cloud Storage" sx={{
                        backgroundColor: activeTab === 5 ? "#44576c" : "transparent",
                        color: activeTab === 5 ? "#ffffff" : "#a1a1a1",
                        fontWeight: activeTab === 5 ? 550 : 500,
                      }} />
                    )} */}
                    {devices.roketchat === "true" && (
                    <Tab label="RocketChat Channel" sx={{
                      backgroundColor: activeTab === 5 ? "#44576c" : "transparent",
                      color: activeTab === 5 ? "#ffffff" : "#a1a1a1",
                      fontWeight: activeTab === 5 ? 550 : 500,
                    }}/>
                    )}
                    </Tabs>
                  <>
                    {/* Tab Content */}
                    <Box sx={{ marginTop: 0.5 }}>
                      {activeTab === 0 && (
                      <>
                        <div className="about-device-actions" style={{display:'flex', justifyContent:'right', gap:'45px'}}>
                                                   
                          {user_type === "DealerUser" &&
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              
                              <Switch
                                checked={this.state.deviceStatusMap}
                                disabled={isDeviceOffline}
                                onChange={(e) =>
                                  this.handleToggleDeviceStatus(this.state.Selected_Device_Id, e.target.checked)
                                }
                                sx={{
                                '& .MuiSwitch-switchBase.Mui-checked': {
                                  color: '#007B00',
                                },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                  backgroundColor: '#007B00',
                                },
                                '& .MuiSwitch-switchBase + .MuiSwitch-track': {
                                  backgroundColor: '#B00020',
                                },
                                '& .MuiSwitch-switchBase': {
                                  color: '#B00020',
                                },
                                
                              }}
                              />
                              <span
                                style={{  
                                  // fontSize: '14px',
                                  fontWeight: 500,
                                  color: '#4ed64e',
                                  transition: 'opacity 0.3s ease, transform 0.3s ease',
                                  // opacity: 1,
                                  transform: 'translateY(0px)',
                                }}
                              >
                                  {this.state.deviceStatusMap
                              ? 'Device Active'
                              :  <span style={{ color: '#cc2c4a' }}>Device Inactive</span>}
                              </span>
                            </div>
                          }
                          <FormControlLabel
                            control={
                              <Tooltip
                                title={
                                  this.state.armDisarmLoading
                                    ? (this.state.isDeviceArmed
                                        ? "Arm command received. Device is in the process of arming. It may take up to 5 minutes for arm status to update."
                                        : "Disarm command received. Device is in the process of disarming. It may take up to 5 minutes for disarm status to update." 
                                      )
                                    : (cameras.length === 0
                                        ? "Add a camera to enable arming"
                                        : isDeviceOffline ? "Device is either 'Offline' or 'Inactive'" : "Arm or disarm the device. Device will automatically disarm/arm at the next scheduled time based on your scheduler settings.")
                                }
                                componentsProps={{
                                            tooltip: {
                                              sx: {
                                                backgroundColor: '#283348',
                                                color: '#fff',
                                                fontSize: '12px',
                                                border: '1px solid #99acb8',
                                              },
                                            },
                                            arrow: {
                                              sx: {
                                                color: '#283348',
                                              },
                                            },
                                          }}
                              >
                                <span>
                                  <Switch
                                    checked={this.state.isDeviceArmed}
                                    onChange={(e) => {
                                      const isChecked = e.target.checked;
                                      if (isChecked) {
                                        this.setState({ showArmDialog: true });
                                      } else {
                                        if (this.state.isDeviceArmed && !this.state.armDisarmLoading) {
                                          this.setState({ showDisarmDialog: true });
                                        } else {
                                          console.warn("Disarm action blocked — either already disarmed or still loading.");
                                        }
                                      }
                                    }}
                                    sx={{
                                      '& .MuiSwitch-switchBase.Mui-checked': {
                                        color: '#4ed64e',
                                      },
                                      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                        backgroundColor: '#4ed64e',
                                      },
                                      '& .MuiSwitch-switchBase + .MuiSwitch-track': {
                                        backgroundColor: '#B00020',
                                      },
                                      '& .MuiSwitch-switchBase': {
                                        color: '#B00020',
                                      },
                                      size: 'smaller',
                                    }}
                                    disabled={isDeviceOffline || !this.state.deviceStatusMap || cameras.length === 0}
                                  />
                                </span>
                              </Tooltip>
                            }
                            label={
                              <span
                                style={{
                                  color: this.state.isDeviceArmed ? '#4ed64e' : '#f92e53',
                                  fontWeight: 500,
                                }}
                              >
                                {this.state.isDeviceArmed ? 'Armed' : 'Disarmed'}
                              </span>
                            }
                          />

                          <Dialog
                            open={this.state.showArmDialog}
                            onClose={() => this.setState({ showArmDialog: false })}
                            PaperProps={{ style: { borderRadius: 8, minWidth: 400 } }}
                          >
                            <DialogTitle style={{ backgroundColor: '#002B5B', color: 'white', fontWeight: 'bold' }}>
                              Arm Device
                            </DialogTitle>

                            <DialogContent>
                              <Typography variant="body2" sx={{ mt: 1, mb: 2 }}>
                                
                               <h4>Device will disarm at next scheduled disarm time.</h4>
                              </Typography>

                            </DialogContent>

                            <DialogActions>
                              <Button
                                id="rowsPerPageButton"
                                onClick={() => this.setState({ showArmDialog: false })}
                              >
                                CANCEL
                              </Button>
                              <Button
                              id="rowsPerPageButton"
                            onClick={() => this.updateArmStatus('armed')}
                            disabled={this.state.armDisarmLoading}
                          >
                            {this.state.armDisarmLoading ? 'Arming...' : 'ARM DEVICE'}
                          </Button>
                            </DialogActions>
                          </Dialog>
                            {/* Disarming */}
                          <Dialog
                            open={this.state.showDisarmDialog}
                            onClose={() => this.setState({ showDisarmDialog: false })}
                            PaperProps={{ style: { borderRadius: 8, minWidth: 400 } }}
                          >
                            <DialogTitle style={{ backgroundColor: '#002B5B', color: 'white', fontWeight: 'bold' }}>
                             Disarm Site
                            </DialogTitle>

                            <DialogContent>
                              <Typography variant="body2" sx={{ mt: 1, mb: 2 }}>
                                
                               <h4>Device will re-arm at the next scheduled arm time.</h4>
                              </Typography>

                            </DialogContent>

                            <DialogActions>
                              <Button
                                id="rowsPerPageButton"
                                onClick={() => this.setState({  showDisarmDialog: false })}
                              >
                                CANCEL
                              </Button>
                              <Button
                              id="rowsPerPageButton"
                          onClick={() => {
                                  this.updateArmStatus("disarmed");
                                  this.setState({ showDisarmDialog: false }); // 👈 close popup after click
                                }}
                            disabled={this.state.armDisarmLoading}
                          >
                            {this.state.armDisarmLoading ? 'Disarming' : 'DISARM'}
                          </Button>
                            </DialogActions>
                          </Dialog>
                          {/* { CloudStorageStatus?.toLowerCase() === "true" && (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              
                              <Switch
                                checked={this.state.cloudStorageStatusMap}
                                disabled={isDeviceOffline || !this.state.deviceStatusMap}
                                onChange={(e) =>
                                  this.setCamerasCloudStorageStatusOnToggle(e.target.checked)
                                }
                                sx={{
                                '& .MuiSwitch-switchBase.Mui-checked': {
                                  color: '#007B00',
                                },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                  backgroundColor: '#007B00',
                                },
                                '& .MuiSwitch-switchBase + .MuiSwitch-track': {
                                  backgroundColor: '#B00020',
                                },
                                '& .MuiSwitch-switchBase': {
                                  color: '#B00020',
                                },
                                
                              }}
                              />
                              <span
                                style={{  
                                  // fontSize: '14px',
                                  fontWeight: 500,
                                  color: '#007B00',
                                  transition: 'opacity 0.3s ease, transform 0.3s ease',
                                  // opacity: 1,
                                  transform: 'translateY(0px)',
                                }}
                              >
                                  {this.state.cloudStorageStatusMap
                              ? 'Cloud Storage Active'
                              :  <span style={{ color: '#B00020' }}>Cloud Storage Inactive</span>}
                              </span>
                            </div>
                          )} */}
                          <Button 
                            onClick={this.ActionLogs}
                          >
                            < SubjectIcon/>
                            <span style={{marginLeft:'3px'}}>Action Logs</span>
                          </Button>
                          <Button 
                            onClick={this.openEditDeviceModal}
                          >
                            < EditNoteIcon/>
                            <span style={{marginLeft:'3px'}}>Edit Device Info</span>
                          </Button> 
                          
                          <img
                            src={SyncIcon1} 
                            alt="sync-icon" 
                            width="50px" 
                            onClick={this.syncSelectedDevice} 
                            title="Sync Device" 
                            style={{cursor:'pointer'}} 
                          />
                        </div>
                        <TableContainer sx={{borderTop: "1px solid #939fb1", borderBottom: "1px solid #939fb1"}}>
                          <Table component={Paper} style={{ tableLayout: 'auto', width: '100%'}}>
                              <TableHead>
                              <TableRow sx={{backgroundColor:'#2a3240'}}>
                                  {[
                                  'Device Name',
                                  'Site Name',
                                  'HDD Storage (Free/Total)',
                                  'Active Cameras',
                                  'Online Cameras',
                                  'Current Site Time',
                                  'Current Device Time',
                                  // 'Online',
                                  'Storage Health',
                                  // 'Armed',
                                  // 'Users',
                                  // 'IP Address',
                                  ].map((header) => {
                                if ((header === 'HDD Storage (Free/Total)' || header === 'Current Device Time' || header === 'Storage Health') && is_rtsp_device) return null;
                                return (
                                  <TableCell key={header} align="center">
                                    <Typography variant="subtitle2" fontWeight="bold" color="#c9d6e8">
                                      {header}
                                    </Typography>
                                  </TableCell>
                                );
                              })}
                              </TableRow>
                              
                              </TableHead>
                              <TableBody>
                              {devices && (
                                  <React.Fragment key={devices.id}>
                                  <TableRow>
                                      <TableCell align="center">
                                        {devices.device_name}
                                      </TableCell>
                                      <TableCell align="center">{devices.site_name || 'N/A'}</TableCell>
                                      {!is_rtsp_device && (
                                      <TableCell align="center" >
                                        {(devices.status === "active" || devices.status === "online") ? (
                                        devices && Array.isArray(devices.hard_disks) && devices.hard_disks.length > 1 ? 
                                        (
                                          <div>
                                            {/* Calculate total storage dynamically */}
                                            {(() => {
                                              const totalFreeSpace = devices.hard_disks.reduce(
                                                (acc, disk) => acc + (parseFloat(disk.free_space_gb) || 0),
                                                0
                                              );
      
                                              const totalSpace = devices.hard_disks.reduce(
                                                (acc, disk) => acc + (parseFloat(disk.total_space_gb) || 0),
                                                0
                                              );
      
                                              return (
                                                <>
                                                  <div style={{ display: "flex", alignItems: "center", gap: "1px" }}>
                                                    {/* <strong>Total: </strong> */}
                                                    <span style={{ color: this.getHDDColor(totalFreeSpace, totalSpace) }}>
                                                      {totalFreeSpace.toFixed(2)}/{totalSpace.toFixed(2)}
                                                    </span>
                                                    <IconButton onClick={() => this.toggleDetails(devices.id)} size="small">
                                                      {/* <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.5 }} /> */}
                                                      <KeyboardArrowDown />
                                                    </IconButton>
                                                  </div>
                                                  {this.state.showDiskDetails[devices.id] && (
                                                    <div>
                                                      {devices.hard_disks.map((disk) => (
                                                        <p key={disk.disk_id} style={{ color: this.getHDDColor(disk.free_space_gb, disk.total_space_gb) }}>
                                                          hdd&nbsp;{disk.disk_id}:&nbsp;{disk.free_space_gb}/{disk.total_space_gb}
                                                        </p>
                                                      ))}
                                                    </div>
                                                  )}
                                                </>
                                              );
                                            })()}
                                          </div>
                                        ) : (
                                          <div>
                                            { (devices && Array.isArray(devices.hard_disks) && devices.hard_disks.length === 1) ?
                                             (devices.hard_disks.map((disk) => (
                                              <p key={disk.disk_id} style={{ color: this.getHDDColor(disk.free_space_gb, disk.total_space_gb) }}>
                                                {disk.free_space_gb}/{disk.total_space_gb}
                                              </p>
                                            ))) : (
                                              <Typography sx={{ color: '#e04a4a'}}>No disk available</Typography>
                                            )}
                                          </div>
                                        )) : (
                                      <Typography>-</Typography>
                                    )
                                  }
                                      </TableCell>
                                      )}
                                      <TableCell align="center" style={{paddingRight:'2px'}}>{devices.total_cameras}</TableCell>
                                      <TableCell align="center">{devices.online_count}</TableCell>
                                      <TableCell align="center">
                                        <div style={{ display: "flex", alignItems: "center", justifyContent:"center", gap: "1px" }}>
                                          {/* <Box color={devices.timezone_match ? 'green' : '#ff3434'}>
                                            {this.getCurrentTimeInDeviceTimezone(devices.site_timezone)}
                                          </Box> */}
                                          {((devices.status === "active" || devices.status === "online") && devices.current_time !== null) ? (
                                            <Box color={devices.timezone_match ? '#38d27b' : '#ff3434'}>
                                            {this.getCurrentTimeInDeviceTimezone(devices.site_timezone)}
                                            </Box>
                                          ) : (
                                            <Box>
                                            {this.getCurrentTimeInDeviceTimezone(devices.site_timezone)}
                                            </Box>
                                          )}
                                          {devices.site_timezone && (
                                            <Tooltip
                                              title={
                                                `Timezone: ${devices.site_timezone}`
                                              }
                                            >
                                              <InfoOutlinedIcon
                                                fontSize="small"
                                                sx={{ ml: 0.5 }}
                                              />
                                            </Tooltip>
                                          )}
                                        </div>
                                      </TableCell>
                                      {!is_rtsp_device && (
                                      <TableCell align="center">
                                        <div style={{ display: "flex", alignItems: "center", justifyContent:"center", gap: "2px" }}>
                                          {(devices.status === "active" || devices.status === "online") ? (
                                            <Box color={devices.timezone_match ? '#38d27b' : '#ff3434'}>
                                            {this.formatToUSDateTime(devices.current_time)} 
                                            </Box>
                                          ) : (
                                            <Box color={'orange'}>
                                            {"--"} 
                                            </Box>
                                          )}
                                          {devices.current_time && (
                                          <Tooltip
                                            title={
                                              `Timezone: ${devices.timezone}`
                                            }
                                          >
                                            <InfoOutlinedIcon
                                              fontSize="small"
                                              sx={{ ml: 0.5 }}
                                            />
                                          </Tooltip>
                                          )}
                                        </div>
                                      </TableCell>
                                      )}
                                      {/* <TableCell align="center">
                                      <Tooltip title={(devices.status === 'active' || devices.status === "online") ? 'Device is active' : 'Device is inactive'}>
                                          {(devices.status === 'active' || devices.status === "online") ? (
                                          <CheckCircleIcon color="success" />
                                          ) : (
                                          <CancelIcon color="error" />
                                          )}
                                      </Tooltip>
                                      </TableCell> */}
                                      {!is_rtsp_device && (
                                      <TableCell align="center" >
                                        {devices && Array.isArray(devices.hard_disks) && devices.hard_disks.length > 0 ? (() => {
                                          const { hard_disks, device_type_name, status, id } = devices;
                                          
                                          const allHikevisionHealthy = hard_disks.every(disk => disk.status === "idle" || disk.status === "ok");
                                          const allNvrHealthy = hard_disks.every(disk => disk.status === "RW" || disk.status === "read/write");
                                          const allDigitalWatchdogHealthy = hard_disks.every(disk => (disk.status === "used|dbReady" || disk.status === "Online"));
                                          const allUNV = hard_disks.every(disk => disk.status === "Normal");
                                          const allDahua = hard_disks.every(disk => disk.status === "ReadWrite");
                                          const allNorthernHealthy = hard_disks.every(disk => disk.status === "RW");

                                          const isHikevision = device_type_name === "hikvision" || device_type_name === "northen";
                                          const isTvtNvr = device_type_name === "nvr";
                                          const isDigitalWatchdog = device_type_name === "digital_watch_dog";
                                          const isUNV = device_type_name === "unv";
                                          const isDahua = device_type_name === "dahua";
                                          const isNorthern = device_type_name === "northern";
        
                                          const multipleDisks = hard_disks.length > 1;
                                          const singleDisk = hard_disks.length === 1;
        
                                          let isHealthy = false;
                                          if (isHikevision) isHealthy = allHikevisionHealthy;
                                          else if (isTvtNvr) isHealthy = allNvrHealthy;
                                          else if (isDigitalWatchdog) isHealthy = allDigitalWatchdogHealthy;
                                          else if (isUNV) isHealthy = allUNV;
                                          else if (isDahua) isHealthy = allDahua;
                                          else if (isNorthern) isHealthy = allNorthernHealthy;
        
                                          return (
                                            <div>
                                              <div style={{ display: "flex", alignItems: "center",justifyContent:"center", gap: "1px" }}>
                                                {(status === "active" || status === "online") ? (
                                                  <Tooltip title={isHealthy ? "All disks are healthy" : "One or more disks have issues"}>
                                                    {isHealthy ? <CheckCircleIcon color="success" /> : <CancelIcon color="error" />}
                                                  </Tooltip>
                                                ) : (
                                                  <Tooltip title="Device is inactive/offline">
                                                    <CancelIcon color="error" />
                                                  </Tooltip>
                                                )}
                                                {multipleDisks ? (
                                                  <IconButton onClick={() => this.toggleDetails(id)} size="small">
                                                    {/* <InfoOutlinedIcon fontSize="small" /> */}
                                                    <KeyboardArrowDown />
                                                  </IconButton>
                                                ) : null}
                                              </div>
        
                                              {multipleDisks && this.state.showDiskDetails[id] && (
                                                <div style={{ marginTop: "5px" }}>
                                                  {hard_disks.map((disk) => {
                                                    const isDiskHealthy =
                                                      (isHikevision && (disk.status === "ok" || disk.status === "idle")) ||
                                                      (isTvtNvr && (disk.status === "RW" || disk.status === "read/write")) ||
                                                      (isDigitalWatchdog && (disk.status === "used|dbReady" || disk.status === "Online")) ||
                                                      (isUNV && (disk.status === "Normal")) ||
                                                      (isDahua && (disk.status === "ReadWrite")) ||
                                                      (isNorthern && (disk.status === "RW"));
                                                      
                                                    return (
                                                      <div key={disk.disk_id} style={{ display: "flex", alignItems: "center",justifyContent:"center", gap: "5px" }}>
                                                        <span>hdd&nbsp;{disk.disk_id}</span>
                                                        <Tooltip
                                                          title={disk.status}
                                                          slotProps={{
                                                            popper: {
                                                              modifiers: [{ name: "offset", options: { offset: [28, -25] } }],
                                                            },
                                                          }}
                                                        >
                                                          {isDiskHealthy ? <CheckCircleIcon color="success" /> : <CancelIcon color="error" />}
                                                        </Tooltip>
                                                      </div>
                                                    );
                                                  })}
                                                </div>
                                              )}
                                            </div>
                                          );
                                        })() : (
                                          <Tooltip title={devices?.status === "inactive" ? "No storage info is available" : "Storage has issues"}>
                                            <CancelIcon color="error" />
                                          </Tooltip>
                                        )}
                                      </TableCell>
                                      )}
                                      
                                      {/* <TableCell align="center">
                                        <div>
                                          <IconButton onClick={(event) => this.handleDeviceKebabClick(event, devices.global_alarm)}>
                                            <MoreVertIcon />
                                          </IconButton>
                                          <Menu
                                            anchorEl={anchorE1}
                                            open={open2}
                                            onClose={this.handleClose}
                                            anchorOrigin={{
                                              vertical: "bottom",
                                              horizontal: "right",
                                            }}
                                            transformOrigin={{
                                              vertical: "top",
                                              horizontal: "right",
                                            }}
                                          >
                                            <MenuItem onClick={()=> this.TestConnection(this.state.selectedDevice)}>Test Connection</MenuItem>
                                            {user_type === "DealerUser" && (
                                            <>
                                            <MenuItem onClick={this.openEditDeviceModal}>Edit</MenuItem>
                                            <MenuItem onClick={() => this.openDialog(() => this.handleDeviceDelete(this.state.selectedDeviceID))}>Delete</MenuItem>
                                            </>
                                            )}
                                          </Menu>
                                        </div>
                                      </TableCell> */}
                                  </TableRow>
                                  
                                  </React.Fragment>
                              )}
                              </TableBody>
                          </Table>

                          <Table component={Paper} style={{ tableLayout: 'auto', width: '100%', marginTop:'6px'}} >
                          <TableHead>
                          <TableRow sx={{backgroundColor:'#2a3240'}} >
                              {[
                              'Last Synchronized',
                              'Last Alert',
                              'Next Video Analysis Schedule',
                              'Online',
                              'Armed',
                              'Users',
                              'IP Address',
                                                              
                              ].map((header) => {
                            if ((header === 'IP Address') && is_rtsp_device) return null;
                            return (
                              <TableCell key={header} align="center">
                                <Typography variant="subtitle2" fontWeight="bold" color="#c9d6e8">
                                  {header}
                                </Typography>
                              </TableCell>
                              
                            );
                          })}
                          {/* <TableCell colSpan={2} >  </TableCell> */}
                          {/* <TableCell colSpan={2} >  </TableCell> */}
                          </TableRow>
                          </TableHead>
                          <TableBody>
                          {devices && (
                              <React.Fragment key={devices.id}>
                                <TableRow>
                                  <TableCell align="center">
                                    <div style={{ display: "flex", alignItems: "center", justifyContent:"center", gap: "1px" }}>
                                    {devices.updated_at
                                    ? new Date(devices.updated_at).toLocaleString("en-US", {
                                        timeZone: devices.site_timezone,
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true
                                      })
                                    : "No alert is available"}
                                    {devices.site_timezone && (
                                        <Tooltip
                                          title={
                                            `Timezone: ${devices.site_timezone}`
                                          }
                                        >
                                          <InfoOutlinedIcon
                                            fontSize="small"
                                            sx={{ ml: 0.5 }}
                                          />
                                        </Tooltip>
                                      )}
                                    </div>
                                  </TableCell>

                                  <TableCell align="center">{devices.last_alert_since ? `${this.normalizeDuration(devices.last_alert_since)} ago` : 'No alert is available'}</TableCell>
                                  
                                  <TableCell align="center" style={{paddingRight:'2px'}}>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent:"center", gap: "1px" }}>
                                      {devices.next_schedule ? this.convertScheduleToDateTime(devices.next_schedule) : 'Schedule is not set'}
                                      {devices.site_timezone && (
                                        <Tooltip
                                          title={
                                            `Timezone: ${devices.site_timezone}`
                                          }
                                        >
                                          <InfoOutlinedIcon
                                            fontSize="small"
                                            sx={{ ml: 0.5 }}
                                          />
                                        </Tooltip>
                                      )}
                                    </div>
                                  </TableCell>
                                  {/* <TableCell colSpan={9} /> */}
                                  
                                  <TableCell align="center">
                                  <Tooltip title={(devices.device_status === "active" && (devices.status === "active" || devices.status === "Online")) ? 'Device is online' : (devices.device_status === "inactive" && (devices.status === "active" || devices.status === "Online") ? 'Device is manually made inactive' : 'Device is offline')}>
                                    {devices.device_status === "active" && (devices.status === 'active' || devices.status === "Online") ? (
                                      <CheckCircleIcon color="success" />
                                    ) : (devices.device_status === "inactive" && (devices.status === 'active' || devices.status === "Online")) ? (
                                          <img src={BlockRoundedIcon} width="24" alt="block_icon" marginTop="8px"/>
                                        ) : (
                                      <CancelIcon color="error" />
                                    )}
                                  </Tooltip>
                                  </TableCell>
                                  <TableCell align="center">
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "5px" }}>
                                      {this.state.armDisarmLoading ? (
                                          <Tooltip title={this.state.armDisarmAction === "arming" ? "Arming..." : "Disarming..."}>
                                          <ReportProblemIcon sx={{ color: '#FFA000' }} /> {/* Amber warning triangle */}
                                        </Tooltip>
                                      ) : this.state.isDeviceArmed ? (
                                        <>
                                          {devices.unmute_count}
                                        <Tooltip title="Device is Armed">
                                          <CheckCircleIcon color="success" />
                                        </Tooltip>
                                        </>
                                      ) : (
                                        <Tooltip title="Device is Disarmed">
                                          <CancelIcon color="error" />
                                        </Tooltip>
                                      )}
                                    </div>
                                    </TableCell>

                                  <TableCell align="center">
                                    {devices?.user_list?.length > 0 ? (
                                      <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1px'}}>
                                        {devices.user_list.length}
                                        <IconButton onClick={() => this.toggleDeviceUserList(devices)} size="small">
                                          <KeyboardArrowDown />
                                        </IconButton>
                                      </span>
                                    ) : (
                                      'No Users'
                                    )}
                                  </TableCell>
                                  {!is_rtsp_device && (
                                  <TableCell align="center" style={{ cursor: 'pointer' }}>
                                    <Tooltip 
                                      title={
                                          <>
                                            {`${devices.protocol}://${devices.ip_address}:${devices.port_number}`}
                                            <br />
                                            <div style={{ textAlign: "center" }}>Click to go to this address</div>
                                          </>
                                        }
                                    >
                                      <a
                                      component="a"
                                      href={`${devices.protocol}://${devices.ip_address}:${devices.port_number}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      >
                                      {/* <img
                                      src={LinkIcon}
                                      alt="ip-globe"
                                      width="26px"
                                      style={{cursor:'pointer'}}
                                      /> */}
                                      <VpnLockRoundedIcon sx={{ backgroundColor: '#b6d1f0', borderRadius: '50%', width:"26px", cursor:'pointer' }} />
                                      </a>
                                    </Tooltip>
                                  </TableCell>
                                  )}
                                </TableRow>
                              </React.Fragment>
                          )}
                          </TableBody>
                          </Table>
                        </TableContainer>
                      </>
                      )}
                      {activeTab === 1 && <Box component={Paper} sx={{border: "1px solid #6e7887", marginTop:'20px'}} > <Scheduler status={devices.status} timezone={devices.timezone} siteTimezone={devices.site_timezone} manualDeviceInactiveStatus={devices.device_status} cameraLength={cameras.length} camera_health_mute_count={this.state.CameraHealthMuteCount} camera_count={devices.total_cameras} /> </Box>}
                      {activeTab === 2 && <Box>
                        {templateEditToggle ? (
                            <TableContainer component={Paper}>
                              <Table style={{ tableLayout: 'fixed', width: '100%'}}>
                                <TableHead>
                                <TableRow sx={{backgroundColor: '#2a3240'}}>
                                    {[
                                    'Device Name',
                                    'Select Template Name',
                                    '',
                                    ].map((header) => (
                                    <TableCell key={header}>
                                        <Typography variant="subtitle2" fontWeight="bold">
                                        {header}
                                        </Typography>
                                    </TableCell>
                                    ))}
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {devices && (
                                    <React.Fragment key={devices.id}>
                                    <TableRow style={{ cursor: 'pointer' }}>
                                        <TableCell>{devices.device_name}</TableCell>
                                        {/* <TableCell> {devices.recording_policy_name} </TableCell> */}
                                        {/* <TableCell>{devices.recording_policy_days}</TableCell>
                                        <TableCell>{devices.hd_capacity_alert}</TableCell> */}
                                        <TableCell>
                                        <select
                                          name="template_name"
                                          value={template_name}
                                          onChange={this.handleInputChange}
                                          style={{fontFamily: "Arial, sans-serif", fontSize:'16x'}}
                                          >
                                                  
                                          <option value="" disabled>Select Template to Apply</option>
                                                  {(Array.isArray(template_list) && template_list.length > 0)?
                                                  template_list.map((temp) => (
                                              <option key={temp.id} value={temp.id}>
                                                  {temp.name}
                                              </option>
                                          )): <option value="" disabled>No Templates Available</option>}
                                          </select>
                                        </TableCell>
                                        <TableCell>
                                          <Button
                                          //  style={{color:'green', border:'1px solid green'}}
                                            id="rowsPerPageButton"
                                            onClick={this.handleUpdateTemplate}>Set Template</Button> &ensp;
                                          <Button
                                          //  style={{color:'#ff3434', border:'1px solid #ff3434'}}
                                          id="clearUserLogButton"
                                            onClick={this.closeTemplateUpdate}>cancel</Button>&nbsp;
                                        </TableCell>
                                        </TableRow>
                                      </React.Fragment>
                                        )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                        ) : (
                            <TableContainer component={Paper} sx={{mt:"10px"}}>
                              <Table style={{ tableLayout: 'fixed', width: '100%'}}>
                                <TableHead>
                                <TableRow sx={{backgroundColor: '#2a3240'}}>
                                    {[
                                    'Device Name',
                                    'Applied Template Name',
                                    'Days',
                                    'Percentage for HDD Capicity',
                                    '',
                                    ].map((header) => (
                                    <TableCell key={header} >
                                        <Typography variant="subtitle2" fontWeight="bold" style={{display:'flex', alignItems:'center'}}>
                                        {header}
                                        {(header === 'Percentage for HDD Capicity') && (
                                          <Tooltip title={'HD capacity percentage (%) that hard-drive can be full before receiving an alert.'}>
                                          <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.5 }} />
                                          </Tooltip>
                                        )}
                                        {(header === 'Days') && (
                                          <Tooltip title={'Look for recordings from the past so many days.'}>
                                          <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.5 }} />
                                          </Tooltip>
                                        )}
                                        </Typography>
                                    </TableCell>
                                    ))}
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {devices && (
                                    <React.Fragment key={devices.id}>
                                    <TableRow>
                                        <TableCell>{devices.device_name}</TableCell>
                                        <TableCell> {devices.recording_policy_name} </TableCell>
                                        <TableCell style={{ cursor: 'default' }}>
                                            {devices.recording_policy_days}
                                        </TableCell>
                                        <TableCell style={{ cursor: 'default' }}>
                                            {devices.hd_capacity_alert}%
                                          </TableCell>
                                        <TableCell style={{ cursor: 'pointer' }}>{user_type === "DealerUser" && (
                                          <img src={EditIconImage} alt="new-edit-icon" width="30px" title="Apply New Template" onClick={this.handleTemplateUpdate}/>
                                           )}
                                        </TableCell>
                                        </TableRow>
                                      </React.Fragment>
                                        )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          
                        )}
                          </Box> 
                      }
                      {activeTab === 3 && <Box component={Paper} sx={{border: '1px solid #5b6e87'}} > <DeviceSpecificNotifications /> </Box>}
                      {activeTab === 4 && 
                        <Box component={Paper} sx={{border: '1px solid #5b6e87'}}>
                         <SmsNotificationsSettings />
                        </Box>
                      }
                      {/* {activeTab === 5 && (
                        <Box>
                        <TableContainer component={Paper}>
                          <Table style={{ tableLayout: 'fixed', width: '100%' }}>
                            
                            <TableHead>
                              {this.state.showCloudEditModal ? (
                                <TableRow>
                                  {['Device Name', 'Select Template Name', 'Number of Days To Keep', ''].map((header, index) => (
                                    <TableCell key={index}>
                                      <Typography variant="subtitle2" fontWeight="bold">
                                        {header}
                                      </Typography>
                                    </TableCell>
                                  ))}
                                </TableRow>
                              ) : (
                                <TableRow>
                                  {[
                                    'Device Name',
                                    'Applied Template Name',
                                    'Days',
                                    '',
                                  ].map((header, index) => (
                                    <TableCell key={index}>
                                      <Typography variant="subtitle2" fontWeight="bold">
                                        {header}
                                      </Typography>
                                    </TableCell>
                                  ))}
                                </TableRow>
                              )}
                            </TableHead>

                            <TableBody>
                              {this.state.showCloudEditModal ? (
                                <TableRow>
                                  <TableCell>{this.state.devices?.device_name || 'N/A'}</TableCell>
                                <TableCell style={{ width: '20%' }}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Select
                            name="storage_template_name"
                            value={storage_template_name}
                            onChange={this.handleInputChange}
                            style={{
                              width: '100%',
                              height: '40px',               // Match TextField height
                              borderRadius: '4px',
                              border: '1px solid rgba(0, 0, 0, 0.23)',  // Match MUI TextField border
                              padding: '0 14px',
                              backgroundColor: '#fbfbfbff',
                              fontSize: '14px',
                              boxSizing: 'border-box',
                              verticalAlign: 'middle', 
                              fontFamily: '"Roboto","Helvetica","Arial",sans-serif'
                            }}
                            // disabled
                            // placeholder="Select Template to Apply"
                          >
                            <MenuItem value="" disabled>
                              Select Template to Apply
                            </MenuItem>
                            <MenuItem value="Default">
                               Default
                            </MenuItem>
                            {(Array.isArray(storage_templates_list) && storage_templates_list.length > 0)?
                              storage_templates_list.map((temp) => (
                              <MenuItem key={temp.id} value={temp.template}>
                                  {temp.template}
                              </MenuItem>
                            )): <MenuItem value="" disabled>No Templates Available</MenuItem>}
                          </Select>
                          </div>
                        </TableCell>

                        <TableCell style={{ width: '20%' }}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                          <TextField
                            placeholder="Days to keep"
                            variant="outlined"
                            size="small"
                            value={this.state.numberOfDays}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (/^\d*$/.test(val)) {
                                this.setState({ numberOfDays: val, daysError: '' });
                              } else {
                                this.setState({ daysError: 'Only numbers allowed' });
                              }
                            }}
                            error={!!this.state.daysError}
                            helperText={this.state.daysError}
                            fullWidth
                            InputProps={{
                              style: {
                                backgroundColor: '#fbfbfbff',
                                fontSize: '14px',
                                height: '40px',            // Match <select> height
                                padding: '0 14px',
                                boxSizing: 'border-box',
                                verticalAlign: 'middle',
                              }
                            }}
                          />
                          </div>
                        </TableCell>
                                  <TableCell align="right">
                                    <Button
                                      variant="contained"
                                      style={{
                                        backgroundColor: '#007b8a',
                                        color: 'white',
                                        marginRight: '10px',
                                        textTransform: 'none',
                                        fontWeight: 'bold',
                                      }}
                                      // disabled
                                      onClick={this.setCloudStorageTemplate}
                                    >
                                      Set Template
                                    </Button>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Button
                                      variant="contained"
                                      style={{
                                        backgroundColor: '#d9534f',
                                        color: 'white',
                                        textTransform: 'none',
                                        fontWeight: 'bold',
                                      }}
                                      onClick={() => this.setState({ showCloudEditModal: false })}
                                    >
                                      Cancel
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              ) : (
                                <TableRow>
                                  <TableCell>{this.state.devices?.device_name || 'N/A'}</TableCell>
                                  <TableCell>  {this.state.applied_storage_template || 'N/A' }</TableCell> 
                                  <TableCell> {this.state.applied_days_for_storage} </TableCell>
                                  <TableCell align="center">
                                    <img
                                      src={EditIconImage}
                                      alt="edit"
                                      title="Edit Template"
                                      style={{
                                        width: 24,
                                        height: 24,
                                        cursor: 'pointer',
                                        verticalAlign: 'middle',
                                      }}
                                      onClick={() => this.setState({ showCloudEditModal: true })}
                                    />
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        </Box>
                      )} */}
                      {activeTab === 5 && <Box component={Paper} sx={{border: '1px solid #5b6e87'}} > <DeviceLevelRocketChat /> </Box>}
                    </Box>
                  </>
                  <>
                    <Box className="about-device-camera-heading" component={Paper} style={{display: 'flex',justifyContent: 'space-between',alignItems: 'center', marginTop: '16px'}}>
                      <Typography variant="h6" gutterBottom sx={{color:'#82b9f8', pl:'8px'}}>
                        Cameras
                      </Typography>
                      <div style={{display:"flex", alignItems:"center"}}>
                      {is_rtsp_device && (
                      <Button
                        id="rowsPerPageButton"
                        onClick={() => this.setState({ toggleAddSingleCamera: true })}
                        variant="contained"
                        style={{cursor: 'pointer'}}
                      >
                        {"+ Add Camera"}
                      </Button>
                      )}
                      {/* <img src={SyncIcon} alt="sync-icon" width="50px" onClick={this.cameraSync} title="Refresh Cameras" style={{cursor:'pointer'}} /> ---> no more needed.*/}
                      </div>
                    </Box>
                      <TableContainer component={Paper} 
                         sx={{
                           border: '1px solid #5b6e87'
                          }}
                          >
                      <Box>
                      <Table style={{ tableLayout: 'auto', width: '100%'}}>
                      <TableHead>
                          {/* <TableRow sx={{backgroundColor:'#2a3240'}} >
                          {[
                              'Camera Name',
                              <>Recording Days <span style={{ color: '#89c6ed' }}>({devices.policy_issues_count || 0})</span></>,
                              <>24hr Recording<br/>Available?</>,
                              'Operator Rating',
                              'AI Rating',
                              'Online',
                              <>Unmute Video Analysis <span style={{ color: '#89c6ed' }}>({devices.unmute_count || 0})</span></>,
                              'Unmute Camera Health',
                              'Ignore Zone',
                              // 'Cloud Storage',
                              'Camera Details',
                              'Actions',
                          ].map((header) => {
                              if ((header === 'Recording Days' || header === '24hr Recording Available?') && is_rtsp_device) return null;
                              if (header === 'Actions' && !is_rtsp_device) return null;
                              return (
                                <TableCell key={header} align="center">
                                  <Typography variant="subtitle2" fontWeight={550} color="#c9d6e8" sx={{ whiteSpace: "nowrap" }}>
                                    {header}
                                  </Typography>
                                </TableCell>
                              );
                            })}
                          </TableRow> */}
                        <TableRow sx={{ backgroundColor: '#2a3240' }}>
                          {[
                            {
                              label: 'Camera Name',
                              content: 'Camera Name',
                            },
                            {
                              label: 'Recording Days',
                              content: (
                                <>
                                  Recording Days<br/><span style={{ color: '#89c6ed' }}> (Cameras with issues:{devices.policy_issues_count || 0})
                                  </span>
                                </>
                              ),
                            },
                            {
                              label: '24hr Recording Available?',
                              content: (
                                <>
                                  24hr Recording<br />
                                  Available?
                                </>
                              ),
                            },
                            {
                              label: 'Operator Rating',
                              content: 'Operator Rating',
                            },
                            {
                              label: 'AI Rating',
                              content: 'AI Rating',
                            },
                            {
                              label: 'Online',
                              content: 'Online',
                            },
                            {
                              label: 'Unmute Video Analysis',
                              content: (
                                <>
                                  Unmute Video<br/>
                                  Analysis <span style={{ color: '#89c6ed' }}>
                                    (Count: {this.state.VideoAnalysisUnmuteCount || 0})
                                  </span>
                                </>
                              ),
                            },
                            {
                              label: 'Unmute Camera Health',
                              // content: 'Unmute Camera Health', //
                              content: (
                                <>
                                  Unmute Camera<br/>
                                  Health <span style={{ color: '#89c6ed' }}>
                                    (Count: {this.state.CameraHealthUnmuteCount || 0})
                                  </span>
                                </>
                              )

                            },
                            {
                              label: 'Ignore Zone',
                              content: 'Ignore Zone',
                            },
                            {
                              label: 'Camera Details',
                              content: 'Camera Details',
                            },
                            {
                              label: 'Actions',
                              content: 'Actions',
                            },
                          ].map((header) => {

                            if (
                              (header.label === 'Recording Days' ||
                                header.label === '24hr Recording Available?') &&
                              is_rtsp_device
                            ) {
                              return null;
                            }

                            if (header.label === 'Actions' && !is_rtsp_device) {
                              return null;
                            }

                            return (
                              <TableCell key={header.label} align="center">
                                <Typography
                                  variant="subtitle2"
                                  fontWeight={550}
                                  color="#c9d6e8"
                                  sx={{
                                    whiteSpace: "nowrap",
                                    lineHeight: 1.2,
                                  }}
                                >
                                  {header.content}
                                </Typography>
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                      {
                      cameras.length > 0 ? (
                        cameras.map((camera) => (
                          <React.Fragment key={camera.id}>
                            <TableRow key={camera.id}>
                              <TableCell
                                
                                onMouseEnter={(e) => this.handleMouseEnter(e, camera)}
                                onMouseLeave={this.handleMouseLeave}
                                style={{ cursor: 'default' }}
                                align="center"
                              >
                                {camera.camera_name}
                              </TableCell>
                              
                              {!is_rtsp_device && (
                              <TableCell 
                                onMouseEnter={(e) => this.handleMouseEnter(e, camera)}
                                onMouseLeave={this.handleMouseLeave}
                                style={{ cursor: 'pointer' }}
                                align="center"
                              >
                                {camera.recording_days < this.state.device_details.recording_policy_days ? (
                                    // <span style={{ color: '#ff3434' }}>
                                    <span style={{ color: '#ff3434' }}>
                                      {/* <img src={RecordingRed} alt="less-recording" width="35px" height="30"/><br /> */}
                                        {camera.recording_days} / 
                                          {this.state.device_details.recording_policy_days ? `${this.state.device_details.recording_policy_days} days` : 'No policy defined'}
                                    </span>
                                ) :(
                                  <span style={{ color: '#38d27b'}}>
                                      {/* <img src={RecordingGreen} alt="less-recording" width="35px" height="30" /><br /> */}
                                          <b>{camera.recording_days} / </b>
                                          <b>{this.state.device_details.recording_policy_days ? `${this.state.device_details.recording_policy_days} days` : 'No policy defined'}</b>
                                    </span>
                                )
                                }
                              </TableCell>

                              )}
                              {!is_rtsp_device && (
                                <TableCell align="center" sx={{color: camera.recording_available_in_last24h === "True" ? "#38d27b" : "#ff3434"}}>
                                {camera.recording_available_in_last24h === "True" ? "Yes" : "No"}
                              </TableCell>
                                )}
                              <TableCell 
                                onMouseEnter={(e) => this.handleMouseEnter(e, camera)}
                                onMouseLeave={this.handleMouseLeave}
                                align="center"
                                style={{cursor: 'pointer', color:(camera.operator_rating === "healthy"? "#38d27b" : camera.ai_rating === "not yet rated" ? "#fff" : "#ff3434")}}
                              > 
                                {camera.operator_rating.charAt(0).toUpperCase() + camera.operator_rating.slice(1) }
                              </TableCell>
                              <TableCell
                                onMouseEnter={(e) => this.handleMouseEnter(e, camera)}
                                onMouseLeave={this.handleMouseLeave}
                                style={{cursor: 'pointer',color:(camera.ai_rating === "healthy"? "#38d27b" : "#fb4f4f")}}
                                align="center"
                               >
                                {((devices.status === 'active' || devices.status === 'online') && (camera.status === 'online' || camera.status === 'Recording' || camera.status === 'videoOn' || camera.status === "active")) 
                                ? (camera.ai_rating.charAt(0).toUpperCase() + camera.ai_rating.slice(1))
                                : ('--') }
                               </TableCell>
                              <TableCell align="center">
                                <Tooltip
                                  title={
                                    ((devices.status === 'active' || devices.status === "online") && (camera.status === "online" || camera.status === "videoOn" || camera.status === "Recording" || camera.status === "active"))
                                      ? "Camera is online"
                                      : "Camera is offline"
                                  }
                                >
                                  {((devices.status === 'active' || devices.status === "online") && (camera.status === "online" || camera.status === "videoOn" || camera.status === "Recording" || camera.status === "active")) ? (
                                    <CheckCircleIcon color="success" />
                                  ) : (
                                    <CancelIcon color="error" />
                                  )}
                                </Tooltip>
                              </TableCell>
                              <TableCell 
                                onClick={() => {
                                  if (camera.snooze) return;
                                  this.toggleMuteUnmuteDIalogue(camera.id);
                                }} 
                                align="center"
                                style={{ cursor: camera.snooze ? "not-allowed" : "pointer", opacity: camera.snooze ? 0.5 : 1 }}
                              >
                                {camera.mute === "True" ? (
                                  <span style={{ cursor: camera.snooze ? "not-allowed" : "pointer", opacity: camera.snooze ? 0.5 : 1 }}>
                                    < NotificationsOffIcon color="error" titleAccess="Muted" />
                                  </span>) : 
                                  <span style={{ cursor: camera.snooze ? "not-allowed" : "pointer", opacity: camera.snooze ? 0.5 : 1 }} >
                                    {/* <img src={UnMuteNotificationIcon} alt="muted Notification" title="Unmuted" width="25px"/>  */}
                                    <NotificationsIcon color="success" titleAccess="Unmuted" />
                                  </span>
                                }
                                
                              </TableCell>
                              <TableCell
                              onClick={() => {
                                  this.toggleCameraHealthMuteUnmuteDIalogue(camera.id);
                                }} 
                                align="center"
                                style={{ cursor: 'pointer'}}
                              >
                                {camera.camera_health_mute === "True" ? (
                                  <span>
                                    < NotificationsOffIcon color="error" titleAccess="Muted" />
                                  </span>) : 
                                  <span>
                                    {/* <img src={UnMuteNotificationIcon} alt="muted Notification" title="Unmuted" width="25px"/>  */}
                                    <NotificationsIcon color="success" titleAccess="Unmuted" />
                                  </span>
                                }
                              </TableCell>
                              
                              <TableCell align="center"> {/*Ignore Zone Column Details Here */}
                                {camera.ignore_zones ? (
                                  <Tooltip title="Ignore zones added">
                                    <CheckCircleIcon color="success" />
                                  </Tooltip>
                                    ) : (
                                  <Tooltip title="No ignore zones added">
                                    <CancelIcon color="error" />
                                  </Tooltip>
                                )}
                              </TableCell> 
                               {/* <TableCell>
                                {this.state.cameraCloudStatus[camera.id] ? (
                                  <Tooltip title="Cloud Storage Enabled">
                                    <CloudDoneIcon
                                      onClick={() => this.handleCloudStatusToggle(camera.id)}
                                      color="success"// Green
                                      cursor= "pointer"
                                    />
                                  </Tooltip>
                                ) : (
                                <Tooltip title="Cloud Storage Disabled">
                                  <CloudUploadIcon
                                    onClick={() => this.handleCloudStatusToggle(camera.id)}
                                    color="error"
                                    cursor= "pointer"
                                  />
                                </Tooltip>
                                )}
                              </TableCell>  */}
                              <TableCell align="center">
                                  <IconButton
                                      onClick={async (e) => {
                                            e.stopPropagation();
                                            await this.closeIgnoreZoneSection(camera.id); // Add this line
                                            this.handleCameraRowClick(camera);
                                      }}
                                      style={{ cursor: 'pointer' }}
                                  >
                                      {nestedExpandedRow === camera.id ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                  <Typography variant="body2" style={{ marginLeft: '1.5px' }}>
                                      {nestedExpandedRow === camera.id ? 'Show Less' : 'Show More'}
                                  </Typography>
                                  </IconButton>
                              </TableCell>
                              {(is_rtsp_device && user_type === "DealerUser") && (
                              <TableCell align="center">
                                <div>
                                  <IconButton onClick={(event) => this.handleCameraKebabClick(event, camera)}>
                                    <MoreVertIcon />
                                  </IconButton>
                                  <Menu
                                    anchorEl={anchorE2}
                                    open={open1}
                                    onClose={this.handleClose}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "right",
                                    }}
                                    transformOrigin={{
                                      vertical: "top",
                                      horizontal: "right",
                                    }}
                                  >
                                    {/* <MenuItem onClick={()=> this.TestConnection(this.state.selectedDevice)}>Test Connection</MenuItem> */}
                                    {/* {user_type === "DealerUser" && (
                                    <> */}
                                    {/* <MenuItem >Snooze</MenuItem> */}
                                    <MenuItem onClick={()=> this.LoadSelectedCameraInfo(this.state.selectedCameraId)}>Edit</MenuItem>
                                    <MenuItem onClick={() => this.openDeleteDialog(() => this.handleCameraDelete(this.state.selectedCameraId))}>Delete</MenuItem>
                                    {/* </>
                                    )} */}
                                  </Menu>
                                </div>
                              </TableCell>
                              )}
                              </TableRow>
                                  {nestedExpandedRow === camera.id && (
                                    <TableRow>
                                      <TableCell colSpan={7.8} style={{ padding: '0', width:'100%' }} align="center">
                                        <div style={{ padding: '16px', border: '1px solid #d1d1e8', borderRadius: '8px', height:'auto', width:'110%', boxShadow: '4px 6px 10px rgba(0, 0, 0, 0.1' }}>
                                            
                                          {toggleIgnoreZone ? (
                                          <>
                                          <div style={{display:'flex', justifyContent:'space-between', width:'100%'}}>
                                              <h3 style={{color:'#82b9f8',  marginBottom: '16px' }}>
                                                Details of Camera: <span style={{ fontWeight: 'bold' }}>{camera.camera_name}</span>
                                              </h3>
                                              <Button id="rowsPerPageButton" style={{height:'25px'}} onClick={()=>this.closeIgnoreZoneSection(camera.id)}>Cancel</Button>
                                          </div>
                                          <div>
                                              <CameraCanvas 
                                                imageSrc={latest_image_path} 
                                                cameraId={camera.id}
                                                cameraName={camera.camera_name}
                                                cameraType={camera.camera_type}
                                                device={camera.device}
                                                rtspUrl={camera.rtsp_url}
                                                sitedb={camera.sitedb}
                                                Image_taken_at={this.state.latest_img_taken_at || camera?.latest_image_timestamp}
                                                CameraStatus={camera.status}
                                                onIgnoreZoneUpdate={this.SpecificCameraSync}
                                              />
                                          </div>
                                          </>
                                          ) : (
                                            <>
                                            <div style={{display:'flex', justifyContent:'space-between', width:'100%'}}>
                                              <h3 style={{color:'#82b9f8', marginBottom: '16px' }}>
                                                Details of Camera: <span style={{ fontWeight: 'bold' }}>{camera.camera_name}</span>
                                              </h3>
                                              <Button id="rowsPerPageButton" style={{height:'25px'}}  onClick={() => {
                                                  // Clear any old data before fetching new
                                                  this.setState({
                                                      latest_image_path: null,
                                                      ignoreZoneSectionCameraId: null
                                                  }, () => {
                                                      this.toggleIgnoreZoneSection(camera.id); // Now fetch fresh image
                                                  });
                                              }}>Zone Settings</Button>
                                            </div>
                                            <div style={{display:'flex',flexDirection: 'row', justifyContent:'space-between', gap: '5px'}}
                                            >
                                              {/* Reference Image Section */}
                                              <div
                                                style={{
                                                  textAlign: 'center',
                                                  border: '0.5px solid rgb(205, 205, 205)',
                                                  borderRadius: '4px',
                                                  padding: '4px',
                                                  width:'30%',
                                                  height:'100%'
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginBottom: '8px',
                                                    fontWeight: 'bold',
                                                    fontSize: '16px',
                                                    color:'#82b9f8',
                                                  }}
                                                >
                                                  <img
                                                    src={MinusIcon}
                                                    alt="Remove"
                                                    title={
                                                      (( devices.status === "inactive" || devices.status === "offline" || devices.device_status === 'inactive') || camera.status === 'offline')
                                                        ? 'Cannot remove the image as device/camera is inactive/offline.'
                                                        : 'Remove Reference Image'
                                                    }
                                                    style={{ width: '40px', marginRight: '8px', cursor: ((devices.status === 'offline' || devices.status === 'inactive' || devices.device_status === 'inactive') || camera.status === 'offline') ? 'not-allowed' : 'pointer' }}
                                                    onClick={((devices.status === 'offline' || devices.status === 'inactive' || devices.device_status === 'inactive') || camera.status === 'offline')
                                                      ? () => alert('Cannot perform the action as device/camera is inactive/offline.')
                                                      :this.deleteReferenceImage}
                                                  />
                                                  <img
                                                    src={PlusIcon}
                                                    alt="Capture"
                                                    title={
                                                      ((devices.status === 'offline' || devices.status === 'inactive' || devices.device_status === 'inactive') || camera.status === 'offline')
                                                        ? 'Cannot capture the image as device/camera is inactive/offline.'
                                                        : 'Capture Reference Image'
                                                    }
                                                    style={{ width: '40px', marginRight: '8px', cursor: ((devices.status === 'offline' || devices.status === 'inactive' || devices.device_status === 'inactive') || camera.status === 'offline') ? 'not-allowed' : 'pointer', opacity: camera.status === 'offline' ? 0.6 : 1, }}
                                                    onClick={((devices.status === 'offline' || devices.status === 'inactive' || devices.device_status === 'inactive') || camera.status === 'offline')
                                                      ? () => alert('Cannot capture the image as camera/device is offline/inactive.')
                                                      : this.capture_snapshot}
                                                  />
                                                  <img
                                                    src={ExclaimIcon}
                                                    alt="Confirm"
                                                    title={
                                                      ((devices.status === 'offline' || devices.status === 'inactive' || devices.device_status === 'inactive') || camera.status === 'offline')
                                                        ? 'Cannot Confirm Reference Image as camera/device is offline/inactive.'
                                                        : 'Confirm Reference Image'
                                                    }
                                                    style={{ width: '40px', cursor: ((devices.status === 'offline' || devices.status === 'inactive' || devices.device_status === 'inactive') || camera.status === 'offline') ? 'not-allowed' : 'pointer', pointerEvents: (devices.status === 'offline' && camera.status === 'offline') ? 'none' : 'auto', }}
                                                    onClick={((devices.status === 'offline' || devices.status === 'inactive' || devices.device_status === 'inactive') || camera.status === 'offline')
                                                      ? () => alert('Cannot Confirm the image as camera/device is offline/inactive.')
                                                      : this.openDialog}
                                                  />
                                                  Reference Image
                                                </div>
                                                <img
                                                  src={selectedCamera?.image1 || camera?.reference_image_url || no_img}
                                                  alt="Camera View 1"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                    // borderRadius: '4px',
                                                  }}
                                                />
                                                <p><b>Image Taken At :</b> {this.state.ref_img_created_time || camera?.reference_image_timestamp}</p>
                                              </div>
                                              
                                              {/* <div style={{display:'flex', justifyContent:'space-between'}}> */}
                                              {/* Image Comparison Section */}
                                              <div
                                                style={{
                                                  display: 'flex',
                                                  justifyContent: 'center',
                                                  alignItems: 'center',
                                                  textAlign: 'center',
                                                }}
                                              >
                                                {camera.reference_image_url && camera.latest_image_url ? (
                                                  (camera.ai_rating === 'healthy' && (devices.status === 'active' || devices.status === 'online') && (camera.status === "online"|| camera.status === "videoOn" || camera.status === "Recording" || camera.status === "active")) ? (
                                                    <img
                                                      src={SameImageStatus}
                                                      alt="same-image"
                                                      title="Both the images are similar"
                                                    />
                                                  ) 
                                                  // : selectedCamera.operator_rating === 'not yet rated' ? (
                                                  //   <img
                                                  //     src={QuestionMarkImage} // Replace with your question mark image variable
                                                  //     alt="question-mark"
                                                  //     title="Operator has not rated"
                                                  //   />
                                                  // )
                                                   : (
                                                    <img
                                                      src={DiffImageStatus} // Default case for "unhealthy" or other values
                                                      alt="diff-img"
                                                      title="Either the images are not similar or not yet rated"
                                                    />
                                                  )
                                                ) 
                                                // : selectedCamera.image1 ? (
                                                //   <img
                                                //     src={QuestionMarkImage}
                                                //     alt="diff-img"
                                                //     title="Images are not similar"
                                                //   />
                                                // )
                                                 : null
                                                }
                                              </div>
                                              {/* Latest Image Section */}
                                              <div
                                                style={{
                                                  textAlign: 'center',
                                                  border: '0.5px solid rgb(205, 205, 205)',
                                                  borderRadius: '4px',
                                                  padding: '4px',
                                                  width:'30%',
                                                  height:'100%'
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    fontWeight: 'bold',
                                                    fontSize: '16px',
                                                    color:'#82b9f8',
                                                    marginBottom: '8px',
                                                  }}
                                                >
                                                  Latest Image
                                                  <img
                                                    src={PlusIcon}
                                                    alt="Capture Latest"
                                                    // title="Capture Latest Image"
                                                    title={
                                                      ((devices.status === 'offline' || devices.status === 'inactive' || devices.device_status === 'inactive') || camera.status === 'offline')
                                                        ? 'Cannot Capture Latest Image as camera/device is offline/inactive.'
                                                        : 'Capture Latest Image'
                                                    }
                                                    style={{ width: '40px', marginLeft: '8px', cursor: ((devices.status === 'offline' || devices.status === 'inactive' || devices.device_status === 'inactive') || camera.status === 'offline') ? 'not-allowed' : 'pointer' }}
                                                    onClick={((devices.status === 'offline' || devices.status === 'inactive' || devices.device_status === 'inactive') || camera.status === 'offline')
                                                      ? () => alert('Cannot Capture the Latest image as camera/device is offline/inactive.')
                                                      : this.capture_Latest_Img_snapshot_Manually}
                                                  />
                                                </div>
                                                <img
                                                  src={((devices.status === 'offline' || devices.status === 'inactive') || camera.status === "offline")
                                                    ? NoCameraConnected
                                                    : (selectedCamera?.image2 || camera?.latest_image_url)
                                                      ? (selectedCamera?.image2 || camera?.latest_image_url)
                                                      : no_img}
                                                  alt="Camera View 2"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                    // borderRadius: '4px',
                                                  }}
                                                />
                                                <p><b>Image Taken At : </b> {(devices.status === 'active' || devices.status === 'online') && (camera.status === "online"|| camera.status === "videoOn" || camera.status === "Recording" || camera.status === "active") ? (this.state.latest_img_taken_at || camera?.description) : ('--')}</p>
                                              </div>
                                              {/* </div> */}

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', flex: 1,marginLeft:'10px', width:'auto', height:'100%' }}>
                                    {[
                                      { label: 'Is Camera Live ? :', value: ((devices.status === 'active' || devices.status === 'online') && (camera.status === 'online' || camera.status === 'Recording' || camera.status === 'videoOn' || camera.status === "active")) ? 'Online' : 'Offline', color: ((devices.status === 'active' || devices.status === 'online') && (camera.status === 'online' || camera.status === 'Recording'|| camera.status === 'videoOn' || camera.status === "active")) ? '#fff' : '#ff3434' },
                                      { label: 'AI Rating : ', value: (((devices.status === 'active' || devices.status === 'online') && (camera.status === 'online' || camera.status === 'Recording' || camera.status === 'videoOn' || camera.status === "active")) ? (camera.ai_rating || 'N/A'):(' --')), color: camera.ai_rating === 'healthy' ? '#38d27b' : '#ff3434'  },
                                      { label: 'Operator Rating : ', value: selectedCamera.operator_rating, color: selectedCamera.operator_rating === 'healthy' ? '#38d27b' : '#ff3434'  },
                                      // { label: 'Port : ', value: camera.port },
                                      ! is_rtsp_device && { label: 'FPS (Main / Sub Stream) : ', value: ((devices.status === 'active' || devices.status === 'online') && (camera.status === 'online' || camera.status === 'Recording' || camera.status === 'videoOn' || camera.status === "active") ? (`${camera.main_stream_fps || 'N/A'} / ${camera.sub_stream_fps || 'N/A'}`) : (' --')), color: '#fff' },
                                      ! is_rtsp_device && { label: 'Resolution (Main / Sub Stream) : ', value: (((devices.status === 'active' || devices.status === 'online') && (camera.status === 'online' || camera.status === 'Recording' || camera.status === 'videoOn' || camera.status === "active")) ? (`${camera.main_stream_resolution || 'N/A'} / ${camera.sub_stream_resolution || 'N/A'}`) : (' --')), color: '#fff' },
                                      { label: 'Stream Stability ? : ',
                                         value:
                                          this.state?.cameraFPSInfo?.detail
                                              ? 'N/A'
                                              : ((devices.status === 'offline') && (this.state?.cameraFPSInfo?.camera?.status === 'offline')
                                                  ? '0'
                                                  : (this.state?.cameraFPSInfo?.camera?.fps || '0')),
                                                    
                                          color: 
                                            ((devices.status === 'active' || devices.status === 'online') && (this.state?.cameraFPSInfo?.camera?.status === 'online'))
                                              ? '#38d27b'
                                              : (this.state?.cameraFPSInfo?.camera?.status === 'offline')
                                              ? '#ff3434'
                                              : 'white',
        
    // tooltip: 
    //   this.state?.cameraFPSInfo?.detail
    //     ? this.state?.cameraFPSInfo?.detail
    //     : `Status: ${this.state?.cameraFPSInfo?.camera?.status || 'unknown'}`,
                                      },
                                    ].map((item, index) => (
                                      <div
                                        key={index}
                                        style={{
                                          display: 'inline-flex',
                                          alignItems: 'center',
                                          fontSize: '14px',
                                          color: '#bababa',
                                          lineHeight: '2',
                                        }}
                                      >
                                        <span style={{ fontWeight: 'bold', marginRight: '4px', fontSize:'14px' }}>{item.label}</span>
                                        <span style={{ color: item.color }} title={item.tooltip} >
                                          {typeof item.value === 'string' 
                                            ? item.value.charAt(0).toUpperCase() + item.value.slice(1) 
                                            : item.value}
                                            {/* Tooltip + Icon beside stream stability value */}
                                            {item.label === "Stream Stability ? : " && this.state?.cameraFPSInfo && (
                                              <Tooltip 
                                                title={
                                                  this.state?.cameraFPSInfo?.detail
                                                    ? "Camera stream is not getting analyzed. Either camera is not found or it is disarmed"
                                                    : (this.state?.cameraFPSInfo?.camera?.status === 'offline'
                                                        ? "Unstable or broken frames of this camera. Retrying to get stable frames... Till then no alerts will be received for this camera."
                                                        : this.state?.cameraFPSInfo?.camera?.status)
                                                }
                                                arrow
                                              >
                                              <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.5, cursor:'pointer' }} />
                                              </Tooltip>
                                            )}
                                        </span>
                                      </div>
                                    ))}

                                    <Typography variant="subtitle1" fontWeight="bold" mt={1}>
                                      Rate Current Camera's Image <span>&#10147;</span>
                                    </Typography>

                                    {/* </button> */}
                                    {/* {activeSection === 'rate' && ( */}
                                    
                                    <div
                                      style={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(3, 1fr)',
                                        marginBottom: '10px',
                                        justifyContent: 'space-between',
                                        gap: '8px',
                                      }}
                                    >
                                      {/* Button list */}
                                      {['healthy', 'blur', 'tilt', 'block', 'fault', 'low light'].map((rating) => {
                                        const isSelected = selectedCamera.operator_rating === rating;
                                        return (
                                        <button
                                          key={rating}
                                          className={`RatingButtons ${rating === 'healthy' ? 'healthy' : 'other'}`}
                                          disabled={!isOnline || (devices.status === 'offline' || devices.status === 'inactive' || devices.device_status === 'inactive' )}
                                          style={{
                                            // backgroundColor: selectedCamera.operator_rating === rating 
                                            //   ? rating === 'healthy' 
                                            //     ? '#77dd77'  // Green for healthy
                                            //     : '#e51a4c'  // Red for others
                                            //   : '', // Default styling
                                            backgroundColor: (!isOnline || (devices.status === 'offline' || devices.status === 'inactive' || devices.device_status === 'inactive'))
                                              ? (isSelected ? '#6c757d' : '#d3d3d3') // darker grey for previous choice, lighter for others
                                              : isSelected
                                                ? (rating === 'healthy' ? '#77dd77' : '#e51a4c')
                                                : '',
                                            color: selectedCamera.operator_rating === rating ? 'white' : '', // White text for selected button
                                            cursor: (isOnline && (devices.status === 'online' || devices.status === 'active' || devices.device_status === 'inactive')) ? 'pointer' : 'not-allowed',
                                          }}
                                          onClick={(isOnline && (devices.status === 'online' || devices.status === 'active' || devices.device_status === 'inactive')) ? () => this.update_operator_rating(rating) : undefined}
                                        >
                                          {/* {rating} */}
                                          {typeof rating === 'string' 
                                            ? rating.charAt(0).toUpperCase() + rating.slice(1) 
                                            : rating}
                                        </button>
                                        );
                                      })}
                                    </div>
                                </div>

                                            </div>
                                          </>
                                          )
                                          }
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  )}
                          </React.Fragment>
                          ))
                      ):!loading ? (
    // Only show this when not loading
                      
                        <TableRow>
                          <TableCell colSpan={6} align="center" style={{color:'orange'}}>
                            No camera is connected. Please connect the camera(s) to this device!
                          </TableCell>
                        </TableRow>
                      ): null}
                      {loading && (
                          <TableRow>
                            <TableCell colSpan={6} align="center">
                              Loading ...
                            </TableCell>
                          </TableRow>
                        )}
                        {/* Load More button row */}
                        {!loading && this.state.pagination.next && (
                          <TableRow>
                            <TableCell colSpan={9} align="center" fontSize="14px">
                              <Button
                                onClick={() =>
                                  this.getCamerasList(
                                    this.state.device_details.id,
                                    (this.state.pagination.currentPage || 1) + 1
                                  )
                                }
                              >
                               <b>Load More</b>
                              </Button>
                            </TableCell>
                          </TableRow>
                        )}                          
                      </TableBody>
                        {open_MuteUnmute_Dialogue && selectedCam && ( 
                                    <div className="modal-mute-unmute">
                                      <div className="modal-content-mute-unmute">
                                        <button className="close-button" onClick={this.handleCloseModal}>
                                            &times;
                                        </button>
                                        {(["online", "videoOn", "Recording", "active"].includes(selectedCam.status) && (devices.status === 'online' || devices.status === 'active')) ? (
                                          <div>
                                            <h3 style={{textAlign:'center'}}>Update Camera Notification settings</h3>
                                            <div style={{display:'flex', justifyContent:'center'}}>
                                              <Button 
                                                onClick={() => this.setState({ mute: true }, () => this.handleMuteUnmuteCameraNotifications(selectedCameraId))}
                                                id="rowsPerPageButton"
                                              >
                                                Mute
                                              </Button> &ensp; 
                                              <Button 
                                                onClick={user_type === "DealerUser"
                                                ? () => this.setState({ mute: false }, () => this.handleMuteUnmuteCameraNotifications(selectedCameraId))
                                                : () => this.handleUnmuteAlert()} 
                                                id="clearUserLogButton"
                                              >Unmute
                                              </Button>
                                            </div>
                                            <div style={{marginTop:'3px'}}>
                                              {error2 ? (
                                                <Alert severity="error">{muteResponseMessage}</Alert>
                                              ) : success2 ? (
                                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                                  {this.state.mute ? "Muted notifications for this camera." : "Unmuted notifications for this camera."}
                                                </Alert>
                                              ) : this.state.success ? (
                                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                                  To Unmute this camera, please Contact Admin !
                                                </Alert>
                                              ): null}
                                            </div>
                                          </div>
                                          )
                                          : (
                                          <div>
                                            <h3 style={{textAlign:'center'}}>Camera is offline</h3>
                                            <p style={{textAlign:'center'}}>Please connect the camera to this device to mute/unmute notifications.</p>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                        )}

                        {open_CameraHealth_MuteUnmute_Dialogue && selectedCam && ( 
                                    <div className="modal-mute-unmute">
                                      <div className="modal-content-mute-unmute">
                                        <button className="close-button" onClick={this.handleCloseModal}>
                                            &times;
                                        </button>
                                          <div>
                                            <h3 style={{textAlign:'center'}}>Update Camera Health Report settings</h3>
                                            <div style={{display:'flex', justifyContent:'center'}}>
                                              <Button 
                                                onClick={() => this.setState({ Camera_report_mute: true }, () => this.handleCameraHealthMuteUnmuteReport(selectedCameraId))}
                                                id="rowsPerPageButton"
                                              >
                                                Mute
                                              </Button> &ensp; 
                                              <Button 
                                                onClick={user_type === "DealerUser"
                                                ? () => this.setState({ Camera_report_mute: false }, () => this.handleCameraHealthMuteUnmuteReport(selectedCameraId))
                                                : () => this.handleUnmuteAlert()} 
                                                id="clearUserLogButton"
                                              >Unmute
                                              </Button>
                                            </div>
                                            <div style={{marginTop:'3px'}}>
                                              {error2 ? (
                                                <Alert severity="error">{muteResponseMessage}</Alert>
                                              ) : success2 ? (
                                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                                  {this.state.mute ? "Muted notifications for this camera." : "Unmuted notifications for this camera."}
                                                </Alert>
                                              ) : this.state.success ? (
                                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                                  To Unmute this camera, please Contact Admin !
                                                </Alert>
                                              ): null}
                                            </div>
                                          </div>
                                          
                                      </div>
                                    </div>
                        )}
                        
                      </Table>
                      </Box>
                      </TableContainer>
                  </>
                </Box>
                
            </Box>

            {/* Main camera Content Layout */}          
            
              <div style={{ marginTop: '2px', display: 'flex', justifyContent: 'center', marginBottom: '3cm', alignItems: 'center' }}>
                <Snackbar
                  open={this.state.open_snackbar}
                  autoHideDuration={5000}
                  onClose={() => this.setState({ open_snackbar: false })}
                  anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
                >
                  <Alert
                    onClose={() => this.setState({ open_snackbar: false })}
                    variant="filled"
                    elevation={6}
                    severity={this.state.alert_type}
                  >
                    {this.state.snackbar_msg}
                  </Alert>
                </Snackbar>
              </div>
              <div>
                {/* <button onClick={this.openDialog}>Delete Item</button> */}
                <DialogBox
                confirmDialog={confirmDialog}
                setConfirmDialog={(updatedDialog) =>
                    this.setState({ confirmDialog: updatedDialog })
                }
                onConfirm={this.save_reference_image}
                onCancel={this.closeDialog}
                />
              </div>
              {/* openDeleteDialog */}
              <div>
                <DialogBox
                confirmDialog={confirmDeleteDialog}
                setConfirmDialog={(updatedDialog) =>
                    this.setState({ confirmDeleteDialog: updatedDialog })
                }
                onConfirm={this.handleCameraDelete}
                onCancel={this.closeDialog}
                />
              </div>
            </div>

            {showDeviceUserList && (
              <div className="modal-device-add">
                <div className="modal-content" style={{height:'auto', maxHeight:'14cm', overflowY:'auto'}}>
                  <p style={{display:'flext',textAlign:'center', alignContent:'center', width:'100%', backgroundColor:'#003366', color:'#fff', height:'1.5cm'}}>Users List</p>
                  <button className="close-button" onClick={this.handleCloseUserListModal}>
                      &times;
                      
                      </button>
                
                  {this.state.selectedDeviceForUserList && this.state.selectedDeviceForUserList.user_list.length > 0 ? (
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell><b>Sr. No.</b></TableCell>
                            <TableCell><b>User Name</b></TableCell>
                            <TableCell><b>Is Admin ?</b></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.selectedDeviceForUserList.user_list.map((user, index) => (
                            <TableRow key={user.id}>
                              <TableCell>{index + 1}</TableCell> {/* Serial Number */}
                              <TableCell>{user.name}</TableCell>
                              <TableCell>{user.isadmin}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <p>No users found</p>
                  )}
                </div>
              </div>
            )}

            {this.state.hoveredCameraImage && (
              <div
                style={{
                  position: 'absolute',
                  top: this.state.hoverPosition.y,
                  left: this.state.hoverPosition.x,
                  border: '1px solid #ccc',
                  borderRadius: '6px',
                  background: '#313030',
                  padding: '4px',
                  boxShadow: '0 2px 8px rgba(135, 135, 135, 0.15)',
                  zIndex: 9999,
                  justifyContent: 'center',
                }}
              >
                <img
                  src={this.state.hoveredCameraImage}
                  alt="Camera Preview"
                  style={{ width: '200px', height: '120px', objectFit: 'cover', borderRadius: '4px' }}
                />
                <Typography variant="caption" align="center" display="block">
                  {/* Latest Image Preview */}
                  {this.state.hoveredCameraImageTimestamp ? `Image Taken At: ${this.state.hoveredCameraImageTimestamp}` : ''}
                </Typography>
              </div>
            )}

            {toggleAddSingleCamera && (
              <div 
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100vh",
                  backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                  zIndex: 999, 
                  display: "flex",
                  justifyContent: "flex-end", 
                  alignItems: "center", // Align vertically
                  }}
              >
                  <div className='Slide-device-Add-form'>
                    {/* Close icon */}
                    <button
                      onClick={this.closePopup}
                      style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      background: "#fff",
                      border: "none",
                      fontSize: "18px",
                      fontWeight: "bold",
                      cursor: "pointer",
                      }}
                    >
                      ✖
                    </button>
                      <div className="form-section" >
                      <h3 style={{ color: '#fff', textAlign: 'center', backgroundColor: '#003366', height: '1cm', alignContent: 'center' }}>Add New RTSP Camera</h3>

                          {warning_camera ? (
                              <Alert severity="warning">Please fill all the required fields.</Alert>
                          ) : error_camera ? (
                              <Alert severity="error"> {this.state.error_camera_message || "Error! New RTSP camera was not added!"}</Alert>
                          ) 
                          // : error1_device ? (
                          //     <Alert severity="error">{responseMessage}</Alert>
                          // ) 
                          // : warning1_device ? (
                          //     <Alert severity="warning">
                          //       "Site added Successfully, but it's not reachable!"
                          //       {/* {responseMessage} */}
                          //       </Alert>
                          // )
                            : success_camera ? (
                              <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                  "All set! The RTSP camera added successfully."
                              </Alert>
                          ) : null}
                                  
                                  <input
                                      type="text"
                                      name="CameraName"
                                      placeholder="Enter Camera Name *"
                                      value={CameraName}
                                      onChange={this.handleInputChange}
                                      style={{ width: "98%"}}
                                  />
                                  <input
                                      type="text"
                                      name="rtspStreamParameter"
                                      placeholder="Enter RTSP Stream Parameter *"
                                      value={rtspStreamParameter}
                                      onChange={this.handleInputChange}
                                      style={{ width: "98%"}} />
                                  <div style={{ display: "flex", justifyContent: "right", gap: "5px", marginTop:'15px' }}>
                                    <Button
                                        type="button"
                                        onClick={this.handleCameraInfoSubmission}
                                        style={{
                                            width: "3.5cm",
                                            height: "0.7cm",
                                            background: 'linear-gradient(145deg,rgb(4, 99, 123),rgb(13, 160, 186))',  // Primary color gradient
                                            boxShadow: 2,
                                            '&:hover': {
                                              background: 'linear-gradient(145deg, #003366,rgb(4, 99, 123))',  // Inverted gradient for hover effect
                                            },
                                            cursor: 'pointer',
                                            color: "white",
                                        }}
                                    >
                                        Add Camera
                                    </Button>
                                  </div>
                      </div>
          
                  </div>
              </div>
            
            )}

            {editCameraToggle &&  (
                <div 
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                    zIndex: 999, 
                    display: "flex",
                    justifyContent: "flex-end", 
                    alignItems: "center", // Align vertically
                    }}
                >
                  <div className='Slide-device-Add-form' >
                      {/* Close icon */}
                      <button
                        onClick={this.closePopup}
                        style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        background: "transparent",
                        border: "none",
                        fontSize: "18px",
                        fontWeight: "bold",
                        cursor: "pointer",
                        }}
                      >
                        ✖
                      </button>
                    <div className="form-section" >
                    <h3 style={{ color: '#fff', textAlign: 'center', backgroundColor: '#003366', height: '1cm', alignContent: 'center' }}>Edit Camera Info</h3>

                    {/* {error && <div className="alert alert-danger" style={{color :'#d9645c', fontSize:'small'}}>{error}</div>}<br/>
                    {success && <div className="alert alert-success">{success}</div>} */}
                    { error_camera_edit ? (
                                  <Alert severity="error">Server Error! Info was not updated!</Alert>
                              ) : success_camera_edit ? (
                                  <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                      "Info updated successfully."
                                  </Alert>
                              ) : warning_camera_edit ? (
                                  <Alert severity="warning">Please fill all the required fields.</Alert>
                              ): null}
                          <div className='form-group-device-edit'>
                            <label htmlFor="user_name">Camera name <span style={{color:'#ff3434'}}>*</span>: &nbsp;</label>
                            <input
                                type="text"
                                name="EditCameraName"
                                value={EditCameraName || ""}
                                onChange={this.handleInputChange}
                                style={{ width: '350px', height: '0.7cm' }}
                            />
                            </div> 
                            
                            
                            <div className='form-group-device-edit'>
                            <label htmlFor="user_name">RTSP Parameter <span style={{color:'#ff3434'}}>*</span>: &nbsp;</label>
                            <input
                                type="text"
                                name="EditRTSPAddress"
                                // placeholder="RTSP Parameter"
                                value={EditRTSPAddress || ""}
                                onChange={this.handleInputChange}
                                style={{ width: '350px', height: '0.7cm' }}
                            />
                            </div>
                            {/* {this.state.errors?.EditRTSPAddress && (
                              <p style={{ color: "#ff3434", fontSize: "12px", display:"flex", justifyContent:"center", marginTop:"1px" }}>{this.state.errors.EditRTSPAddress}</p>
                            )} */}
                            <div style={{display:'flex', justifyContent:'right', gap:'5px', marginTop:'15px'}}>
                                                            <Button type="button" onClick={() => this.handleSaveCameraEditedInfo(selectedCameraId)}
                                                            style={{
                                                              width: "3.5cm",
                                                              height: "0.7cm",
                                                              background: 'linear-gradient(145deg,rgb(4, 99, 123),rgb(13, 160, 186))',  // Primary color gradient
                                                              boxShadow: 2,
                                                              '&:hover': {
                                                                background: 'linear-gradient(145deg, #003366,rgb(4, 99, 123))',  // Inverted gradient for hover effect
                                                              },
                                                              cursor: 'pointer',
                                                              color: "white",
                                                          }}
                                                            > Save Info </Button>
                                                            <Button type="button" onClick={this.closePopup} style={{width:'0.8cm', height:'0.7cm', backgroundColor:'#e02e2e', color:'white'}}> Cancel </Button>
                                                          </div>
                            
                    </div>
                  </div> 
                </div>
            )}

            {editDeviceToggle &&  (
              <div 
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100vh",
                  backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                  zIndex: 999, 
                  display: "flex",
                  justifyContent: "flex-end", 
                  alignItems: "center", // Align vertically
                  }}
              >
                <div className='Slide-device-Add-form' >
                    {/* Close icon */}
                    <button
                      onClick={this.closePopup}
                      style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      background: "#fff",
                      border: "none",
                      fontSize: "18px",
                      fontWeight: "bold",
                      cursor: "pointer",
                      }}
                    >
                      ✖
                    </button>
                  <div className="form-section" >
                  {/* <h3 style={{color:'#001668', textAlign:'center', backgroundColor:'#dbeffd', height:'1cm', alignContent:'center'}}>Edit Device Info</h3> */}
                  <h3 style={{ color: '#fff', textAlign: 'center', backgroundColor: '#003366', height: '1cm', alignContent: 'center' }}>Edit Device Info</h3>

                  {/* {error && <div className="alert alert-danger" style={{color :'#d9645c', fontSize:'small'}}>{error}</div>}<br/>
                  {success && <div className="alert alert-success">{success}</div>} */}
                  { warning_device ? (
                                <Alert severity="warning">Please fill all the required fields correctly.</Alert>
                            ) :error_device_edit ? (
                                <Alert severity="error">{responseMessage}</Alert>
                            ) : success_device_edit ? (
                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                    "Info updated successfully."
                                </Alert>
                            ) : null}
                        <div className='form-group-device-edit'>
                          <label htmlFor="user_name">Device name <span style={{color:'#ff3434'}}>*</span>: &nbsp;</label>
                          <input
                              type="text"
                              name="EditDeviceName"
                              value={EditDeviceName || ""}
                              onChange={this.handleInputChange}
                              style={{ width: '350px', height: '0.7cm' }}
                          />
                          </div>
                          {(!is_rtsp_device) && (
                          <div className='form-group-device-edit'>
                            <label htmlFor="user_name">Device Type <span style={{color:'#ff3434'}}>*</span>
                            <Tooltip 
                              title={'You can not edit the device type. If you need to change this please delete this device first and add new one'}
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: '#283348',
                                    color: '#fff',
                                    fontSize: '12px',
                                    border: '1px solid #99acb8',
                                  },
                                },
                                arrow: {
                                  sx: {
                                    color: '#283348',
                                  },
                                },
                              }}
                            >
                              <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.8 }} />
                            </Tooltip>
                            : &nbsp;</label>
                            <select
                                name="EditDeviceType"
                                placeholder="Device Type"
                                value={EditDeviceType || ""}
                                // onChange={this.handleInputChange}
                                style={{ width: '350px', height: '0.9cm', pointerEvents: 'none' }}
                            >
                                <option value="" disabled>Select Device Type</option>
                                {(device_type_list|| []).map((type) => (
                                    <option key={type.id} value={type.id}>
                                        {type.type_name
                                        .replace(/_/g, " ")
                                        .replace(/\b\w/g, (char) => char.toUpperCase())}
                                    </option>
                                ))}
                            </select>
                          </div>
                          )}
                          <div className='form-group-device-edit'>
                          <label htmlFor="user_name">IP Address <span style={{color:'#ff3434'}}>*</span>: &nbsp;</label>
                          <input
                              type="text"
                              name="EditIpAddress"
                              placeholder="IP Address"
                              value={EditIpAddress || ""}
                              onChange={this.handleInputChange}
                              style={{ width: '350px', height: '0.7cm' }}
                          />
                          </div>
                          {this.state.errors?.EditIpAddress && (
                            <p style={{ color: "#ff3434", fontSize: "12px", display:"flex", justifyContent:"center", marginTop:"1px" }}>{this.state.errors.EditIpAddress}</p>
                          )}
                          <div className='form-group-device-edit'>
                          <label htmlFor="user_name">RTSP <span style={{color:'#ff3434'}}>*</span>: &nbsp;</label>
                          <input
                              type="number"
                              name="EditRTSPAddress"
                              placeholder="RTSP "
                              value={EditRTSPAddress || ""}
                              onChange={this.handleInputChange}
                              style={{ width: '350px', height: '0.7cm' }}
                          />
                          </div>
                          {this.state.errors?.EditRTSPAddress && (
                            <p style={{ color: "#ff3434", fontSize: "12px", display:"flex", justifyContent:"center", marginTop:"1px" }}>{this.state.errors.EditRTSPAddress}</p>
                          )}
                          <div className='form-group-device-edit'>
                          <label htmlFor="user_name">Protocol <span style={{color:'#ff3434'}}>*</span>: &nbsp;</label>
                          <select
                              name="EditProtocol"
                              value={EditProtocol || ""}
                              onChange={this.handleInputChange}
                              style={{ width: '350px', height: '0.9cm' }}
                          >
                          <option value="" disabled>Select HTTP Protocol</option>
                          
                          {is_rtsp_device ? (
                            <option value="rtsp">RTSP</option>
                          ) : (
                          <>
                            <option value="http">HTTP</option>
                            <option value="https">HTTPS</option>
                          </>
                          )}
                          </select>
                          </div>
                          <div className='form-group-device-edit'>
                          <label htmlFor="user_name">HTTP Port Number<span style={{color:'#ff3434'}}>*</span>: &nbsp;</label>
                          <input
                              type="number"
                              name="EditPortNumber"
                              value={EditPortNumber || ""}
                              onChange={this.handleInputChange}
                              style={{ width: '350px', height: '0.7cm' }}
                          />
                          </div>
                          {this.state.errors?.EditPortNumber && (
                            <p style={{ color: "#ff3434", fontSize: "12px", display:"flex", justifyContent:"center", marginTop:"1px"}}>{this.state.errors.EditPortNumber}</p>
                          )}
                          <div className='form-group-device-edit'>
                          <label htmlFor="user_name">Device Username<span style={{color:'#ff3434'}}>*</span>: &nbsp;</label>
                          <input
                              type="text"
                              name="EditDeviceUsername"
                              value={EditDeviceUsername || ""}
                              onChange={this.handleInputChange}
                              style={{ width: '350px', height: '0.7cm' }}
                          />
                          </div>
                          <div className='form-group-device-edit'>
                            <label htmlFor="user_name" style={{marginLeft:'-2px' }}>Device Password<span style={{color:'#ff3434'}}>*</span>:</label>
                            <div style={{ position: "relative", display: "inline-block",  width: '350px'}}>
                              <input
                                  type={passwordShown ? "text" : "password"}
                                  name="EditDevicePassword"
                                  value={EditDevicePassword || ""}
                                  onChange={this.handleInputChange}
                                  style={{ width: '350px', height: '0.7cm' }}
                              />
                              <span
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "48%",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                }}
                              >
                                {/* {showPassword ? <EyeOff size={16} /> : <Eye size={16} />} */}
                                {(password_visibility?.toLowerCase() === "true" || user_type === "DealerUser") && 
                                  <img onClick={this.togglePasswordVisiblity} src={passwordEye} alt="password-eye" width='25' height='25' />
                                }
                              </span>
                            </div>
                          </div>
                        <div style={{display:'flex', justifyContent:'right', gap:'5px', marginTop:'15px'}}>
                          <Button type="button" onClick={() => this.handleSaveDeviceEditedInfo(Selected_Device_Id)}
                          style={{
                            width: "3.5cm",
                            height: "0.7cm",
                            background: 'linear-gradient(145deg,rgb(4, 99, 123),rgb(13, 160, 186))',  // Primary color gradient
                            boxShadow: 2,
                            '&:hover': {
                              background: 'linear-gradient(145deg, #003366,rgb(4, 99, 123))',  // Inverted gradient for hover effect
                            },
                            cursor: 'pointer',
                            color: "white",
                        }}
                          > Save Info </Button>
                          <Button type="button" onClick={this.closePopup} style={{width:'0.8cm', height:'0.7cm', backgroundColor:'#e02e2e', color:'white'}}> Cancel </Button>
                        </div>
                  </div>
                </div> 
              </div>
            )}

            {/* Backdrop with Circular Progress */}
            <Backdrop open={this.state.open_progress_bar}>
              <div className="custom-spinner">
                  <div className="circle"></div>
                  <div className="circle tilted"></div>
                  <img src={this.state.storedLogo ? this.state.storedLogo : WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
              </div>
              {/* <CircularProgress size={80} color="inherit" /> */}
            </Backdrop>
        </div>
      </ThemeProvider>
      );
  }
}

export default withNavigate(AboutDevice);
